export default {
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "basePath": "/104/es",
  "title": "ESCRIME XXI N⁰ 104",
  "shortTitle": "",
  "description": "Fencing Magazine",
  "width": 1536,
  "height": 1152,
  "currentLanguage": "ES",
  "companyLogo": "escrime-logo.png",
  "languages": [{
    "code": "EN",
    "text": "English",
    "href": "http://escrime-xxi.fie.org/104/en"
  },
  {
    "code": "FR",
    "text": "French",
    "href": "http://escrime-xxi.fie.org/104/fr"
  },
  {
    "code": "ES",
    "text": "Spanish",
    "href": "http://escrime-xxi.fie.org"
  }],
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": false,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": false,
    "printEnabled": false,
    "zoomEnabled": true,
    "contentsEnabled": true,
    "languagesEnabled": true,
    "mobileSwitch": true,
    "downloadPath": ""
  },
  "pages": [
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 0,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg1.png",
      "zoom": null,
      "content": `
        <img id="1-0" class="halfScale" src="/104/es/static/_content/1-logo-2.png" style="top: 0; left: 378px;opacity:1;" />
        <img id="1-1" class="halfScale" src="/104/es/static/_content/1-logo-1.png" style="top: 111px; left: 69px;" />
        <img id="1-2" class="halfScale" src="/104/es/static/_content/1-logo-3.png" style="top: 277px; left: 70px;" />
        <img id="1-3" class="halfScale" src="/104/es/static/_content/1-logo-4.png" style="top: 111px; left:1080px;" />
        <img id="1-5" class="1-text halfScale pointer" src="/104/es/static/_content/1-t1.png" style="top: 358px; left: 0px;" onclick="Publish.goToPage(40)" />
        <img id="1-6" class="1-text halfScale pointer" src="/104/es/static/_content/1-t2.png" style="top: 516px; left: 0px;" onclick="Publish.goToPage(43)"/>
        <img id="1-7" class="1-text halfScale pointer" src="/104/es/static/_content/1-t3.png" style="top: 704px; left: 0px;" onclick="Publish.goToPage(9)"/>
        <img id="1-8" class="halfScaleBR pointer" src="/104/es/static/_content/1-next.png" style="bottom:60px; right: 0px;" onclick="Publish.goToNextPage()"/>
      `,
      "script": `
        function onPageEnter() {
          page1Anim = new TimelineMax()
          page1Anim
          .fromTo(idOf("1-1"), 0.8, {x: -300, opacity:0}, {x: 0, opacity: 1}, 0.5)
          .fromTo(idOf("1-0"), 0.5, {x: -300, opacity:0}, {x: 0, opacity: 1, ease: Back.easeOut.config(1.7)},"-=0.2")
          .fromTo(idOf("1-2"), 0.5, {x: -30, opacity:0}, {x: 0, opacity:1},"-=0.2")
          .fromTo(idOf("1-3"), 0.5, {x: -30, opacity:0}, {x: 0, opacity:1},"-=0.2")
          .staggerFromTo(cOf("1-text"), 0.8, {x:-200, opacity:0}, {x:0,  opacity:1},0.2, "+=0",addContentLinks)
          .fromTo(idOf("1-8"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1})
        }

        function onPageLeave() {
          page1Anim.stop()
          removeContentLinks()
        }
      `,
      "searchText": "",
      "mobileHtml": "<img src=\"/104/es/static/_mobile/cover-mobile.jpg\">",
      
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Instrucciones De Uso",
      "index": 1,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg2.png",
      "zoom": null,
      "content": `
        <img id="howtotitle" class="halfScale" style="top:85px;left:85px;" src="/104/es/static/_content/2-title.png">
        <img class="desktopOnly howto-desktop halfScaleR" id="howto-btn-desktop" style="top:126px;right:286px;" src="/104/es/static/_content/2-desktop.png">
        <img class="tabletOnly howto-ipad halfScaleR" id="howto-btn-ipad" style="top:126px;right:83px;" src="/104/es/static/_content/2-ipad.png">
        <img class="desktopOnly howto-desktop halfScale" style="top:265px;left:82px;" src="/104/es/static/_content/2-desktop-main.png">
        <img class="tabletOnly howto-ipad halfScale" style="top:275px;left:82px;" src="/104/es/static/_content/2-ipad-main.png">
        <img class="howto-hotspot halfScaleB" style="bottom:147px;left:157px;" src="/104/es/static/_content/2-pop.png">
        <img class="howto-hotspot halfScaleB" style="bottom:122px;left:457px;" src="/104/es/static/_content/2-play.png">
        <img class="howto-hotspot halfScaleB" style="bottom:115px;left:830px;" src="/104/es/static/_content/2-social.png">
        <img class="howto-hotspot halfScaleB" style="bottom:117px;left:1155px;" src="/104/es/static/_content/2-numbers.png">

        <img class="abs pointer hover halfScaleR" onclick="switchPopHowto(true);" style="top:126px;right:286px;" src="/104/es/static/_content/2-desktop.png">
        <img class="abs pointer hover halfScaleR" onclick="switchPopHowto(false);" style="top:126px;right:83px; "src="/104/es/static/_content/2-ipad.png">

        <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
          <a href="http://www.fie.org/es" target="_blank"></a>
        </div>
      `,
      "script": `
        function onPageEnter() {
          addContentLinks()
        }

        function btnOverHowto(el){
          el.style.display = "block";
          TweenMax.to(el, 0.5, {opacity:1});
        }

        function btnOutHowto(el){
          TweenMax.to(el, 0.5, {opacity:0, onComplete:function(){
            el.style.display = "none";
          }});
        }

        function switchPopHowto(bool){
          if(bool){
            TweenMax.to(cOf("howto-ipad"), 0.5, {opacity:0, onComplete:function(){
              cOf("howto-ipad")[0].style.display = "none";
              cOf("howto-ipad")[1].style.display = "none";
            }});
            cOf("howto-desktop")[0].style.display = "block";
            cOf("howto-desktop")[1].style.display = "block";
            TweenMax.to(cOf("howto-desktop"), 0.5, {opacity:1});
          }else{
            cOf("howto-ipad")[0].style.display = "block";
            cOf("howto-ipad")[1].style.display = "block";
            TweenMax.to(cOf("howto-ipad"), 0.5, {opacity:1});
            TweenMax.to(cOf("howto-desktop"), 0.5, {opacity:0, onComplete:function(){
              cOf("howto-desktop")[0].style.display = "none";
              cOf("howto-desktop")[1].style.display = "none";
            }});
          }
        }

        function onPageLeave() {
          removeContentLinks()
        }
      `,
      "searchText": ""
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 2,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg3.png",
      "zoom": null,
      "content": `
        <!--<svg class="abs pulse animatedpulse" style="bottom:260px;left:237px;" width="69.4px" height="67.4px" viewBox="0 0 69.4 67.4">
          <path fill="#231F20" d="M52,34.4L24,50.6V18.1L52,34.4z M67.4,33.7C67.4,15.1,52.3,0,33.7,0C15.1,0,0,15.1,0,33.7
          c0,18.6,15.1,33.7,33.7,33.7C52.3,67.4,67.4,52.3,67.4,33.7"/>
        </svg> -->

        <div class="contentLink" style="bottom:26px;right:41px;width:280px; height:25px;">
          <a href="http://www.tissotwatches.com" target="_blank"></a>
        </div>

        <!--<div class="abs pointer" onclick="Publish.openVideo('/104/es/static/_content/vid-tissot.mp4');" style="bottom:200px;left:220px;width:130px;height:140px;"></div>-->
      `,
      "script": `
        function onPageEnter() {
          addContentLinks()
        }

        function onPageLeave() {
          removeContentLinks()
        }
      `,
      "searchText": "Tissot Anuncio",
      "mobileHtml": `
      <a href="http://www.tissotwatches.com" target="_blank">
        <img id="tissotimg" src="/104/es/static/_mobile/pg3-tissot.jpg" alt="Tissot Advert">
      </a>
      <!--<h4><a onclick="Publish.openVideo('/104/es/static/_content/vid-tissot.mp4');" target="_blank">Haga clic aquí para reproducir el vídeo</a></h4>-->
      `
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Contents",
      "index": 3,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg4.png",
      "zoom": null,
      "content": `
        <img id="4-title" class="halfScale" style="top:85px;left:85px;" src="/104/es/static/_content/4-title.png">
        <img class="cont-item cont-item-1-btn halfScale" style="top:328px;left:574px;opacity:0;" src="/104/es/static/_content/4-fore.jpg">
        <img class="cont-item cont-item-2-btn halfScale" style="top:339px;left:574px;opacity:0;" src="/104/es/static/_content/4-sport.jpg">
        <img class="cont-item cont-item-3-btn halfScale" style="top:359px;left:574px;opacity:0;" src="/104/es/static/_content/4-preview.jpg">
        <img class="cont-item cont-item-4-btn halfScale" style="top:352px;left:574px;opacity:0;" src="/104/es/static/_content/4-interview.jpg">
        <img class="cont-item cont-item-5-btn halfScale" style="top:328px;left:574px;opacity:0;" src="/104/es/static/_content/4-fie-news.jpg">
        <img class="cont-item cont-item-6-btn halfScale" style="top:359px;left:574px;opacity:0;" src="/104/es/static/_content/4-news.jpg">
        <div class="contentLink" onclick="contentsBub(1);" style="top:359px; left:86px; width: 490px; height: 60px;"></div>
        <div class="contentLink" onclick="contentsBub(2);" style="top:451px; left:86px; width: 490px; height: 60px;"></div>
        <div class="contentLink" onclick="contentsBub(3);" style="top:544px; left:86px; width: 490px; height: 60px;"></div>
        <div class="contentLink" onclick="contentsBub(4);" style="top:636px; left:86px; width: 490px; height: 60px;"></div>
        <div class="contentLink" onclick="contentsBub(5);" style="top:728px; left:86px; width: 490px; height: 60px;"></div>
        <div class="contentLink" onclick="contentsBub(6);" style="top:820px; left:86px; width: 490px; height: 60px;"></div>
        <div class="contentLink" style="top: 185px; left:80px;width:145px; height: 50px;">
          <a href="http://www.fie.org/es" target="_blank"></a></div>
        <div class="contentLink" style="top: 75px; right:623px;width:55px; height: 55px;">
          <a href="https://www.facebook.com/fie.org" target="_blank"></a></div>
        <div class="contentLink" style="top:130px; right:623px;width:55px; height: 55px;">
          <a href="https://twitter.com/FIE_fencing" target="_blank"></a></div>
        <div class="contentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
          <a href="http://www.fie.org/es" target="_blank"></a></div>
        <div class="contentLink cont-item-1-link" onclick="Publish.goToPage(6)" style="top:359px;left:648px;width:570px;height:345px;display:none;"></div>
        <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(9)" style="top:451px;left:648px;width:570px;height:526px;display:none;"></div>
        <div class="contentLink cont-item-3-link" onclick="Publish.goToPage(40)" style="top:544px;left:648px;width:645px;height:430px;display:none;"></div>
        <div class="contentLink cont-item-4-link" onclick="Publish.goToPage(43)" style="top:358px;left:648px;width:570px;height:340px;display:none;"></div>
        <div class="contentLink cont-item-5-link" onclick="Publish.goToPage(46)" style="top:451px;left:648px;width:570px;height:63px;display:none;"></div>
        <div class="contentLink cont-item-5-link" onclick="Publish.goToPage(48)" style="top:543px;left:648px;width:570px;height:63px;display:none;"></div>
        <div class="contentLink cont-item-5-link" onclick="Publish.goToPage(50)" style="top:633px;left:648px;width:570px;height:63px;display:none;"></div>
        <div class="contentLink cont-item-5-link" onclick="Publish.goToPage(52)" style="top:728px;left:648px;width:570px;height:218px;display:none;"></div>
        <div class="contentLink cont-item-5-link" onclick="Publish.goToPage(54)" style="top:971px;left:648px;width:570px;height:63px;display:none;"></div>
        <div class="contentLink cont-item-6-link" onclick="Publish.goToPage(57);showPageOverlay('news-pop-2')" style="top:451px;left:646px;width:570px;height:433px;display:none;"></div>
        <div class="contentLink cont-item-6-link" onclick="Publish.goToPage(57);showPageOverlay('news-pop-3')" style="top:911px;left:646px;width:570px;height:63px;display:none;"></div>
        <div class="contentLink cont-item-6-link" onclick="Publish.goToPage(57);showPageOverlay('news-pop-1')" style="top:1003px;left:646px;width:570px;height:63px;display:none;"></div>
        
        <img id="4-arrow" class="pointer halfScaleBR" src="/104/es/static/_content/4-next.png" style="bottom:60px; right: 0px;" onclick="Publish.nextPage();"/>
      `,
      "script": `
        function onPageEnter() {
          page4Anim = new TimelineMax();
          
          page4Anim.fromTo(idOf("4-title"), 0.3,{x:-100,opacity:0}, {x:0,opacity:1}, 0.5)
          .fromTo(idOf("4-arrow"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut},"-=0.2")
        }


        function contentsBub(index){
          TweenMax.to(cOf("cont-hide"), 0.5, {opacity:0})
          console.log("contentsBub", index)
          for(var i=1; i <= 7; i++){
            if(i == index){
              [].slice.call(cOf("cont-item-"+i+"-link")).reduce(function(p,c){
                console.log(c)
                c.style.display = "";
              },0);
              TweenMax.to(cOf("cont-item-"+i+"-btn"), 0.5, {opacity:1, onComplete:function(){
                /*
                classc("cont-item-"+index+"-link")[0].style.display = ""
                if(classc("cont-item-"+index+"-link")[1]){
                  classc("cont-item-"+index+"-link")[1].style.display = ""        
                }
                */
              }});
            }else{
              [].slice.call(cOf("cont-item-"+i+"-link")).reduce(function(p,c){
                  c.style.display = "none";
                },0);
              TweenMax.to(cOf("cont-item-"+i+"-btn"), 0.5, {opacity:0});
            }
          }
        }

        function onPageLeave() {
          page4Anim.stop()
          removeContentLinks()
        }
      `,
      "searchText": ""
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Comité Ejecutivo de la FIE",
      "index": 4,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg5.png",
      "zoom": null,
      "content": `
        <img id="5-arrow" class="pointer halfScaleBR" src="/104/es/static/_content/4-next.png" style="bottom:136px; right: 21px;" onclick="Publish.nextPage();"/>
        
        <div class="addContentLink" style="bottom:43px; left:81px;width: 67px; height: 67px;">
          <a href="https://twitter.com/FIE_fencing" target="_blank"></a></div>
        <div class="addContentLink" style="bottom:43px; left:151px;width: 67px; height: 67px;">
          <a href="https://www.facebook.com/fie.org" target="_blank"></a></div>
        <div class="addContentLink" style="bottom:43px; left:221px;width: 67px; height: 67px;">
          <a href="https://www.youtube.com/user/FIEvideo" target="_blank"></a></div>
        <div class="addContentLink" style="bottom:242px;left:745px;width:100px;height:26px;">
          <a href="mailto:info@fie.ch" target="_blank"></a></div>
        <div class="addContentLink" style="bottom:212px;left:686px;width:105px;height:26px;">
          <a href="http://www.fie.org/es" target="_blank"></a></div>
        <div class="addContentLink" style="bottom:154px;right:398px;width:220px;height:30px;">
          <a href="http://www.touchline.com" target="_blank"></a></div>
        <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
          <a href="http://www.fie.org/es" target="_blank"></a></div>
      `,
      "script": `
        function onPageEnter() {
          page5Anim = new TimelineMax();
          
          page5Anim.fromTo(idOf("5-arrow"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 0.5)
        }

        function onPageLeave() {
          page5Anim.stop()
          removeContentLinks()
        }
      `,
      "searchText": `Presidente: Alisher Usmanov (RUS)
      Secretario general: Emmanuel Katsiadakis (M.H.) (GRE)
      Secretaria tesorera: Ferial Nadira Salhi (ALG)

Vice Presidentes:
Ana Pascu (M.H.) (ROU)
Donald Anthony (USA)
Wei Wang (CHN)
Members
Erika Aze (LAT)
Jacek Bierkowski (POL)
Velichka Hristeva (BUL)
Isabelle Lamour (FRA)
Yuki Ota (JPN)
Novak Perovic (RSA)
Oleg Peskov (KAZ)
Giorgio Scarso (ITA)
Bence Szabo (HUN)
Pascal Tesch (LUX)
Aldo Montano (ITA)

Presidente de la Confederación Africana de Esgrima: Mbagnick Ndiaye (SEN) 
Presidente de la Confederación Panamericana de Esgrima: Vitaly Logvin (MEX) 
Presidente de la Confederación Asiática de Esgrima: Celso L. Dayrit (M.H.) (PHI) 
Presidente de la Confederación Europea de Esgrima: Stanislav Pozdnyakov (RUS)
Presidente de la Confederación Oceánica de Esgrima: Helen Smith (M.H.) (AUS)

OFICINA CENTRAL DE LA FIE
Directora general
Nathalie Rodriguez M.-H. (FRA)

Administración
Directora administrativa:  Elena Murdaca (ITA)
Gestora de contabilidad:  Margarita Berdoz (BUL) 
Asistente de dirección:  Gabrielle Meylan (BRA)
Asistente administrativa:  Ylenia Murdaca (ITA)

Deporte
Director técnico y deportivo:  
Evgeny Tsoukhlo (RUS)
Manager de la tecnología y de la administración del deporte: Natalia Bodrova (RUS)
Manager de operaciones del deporte:  
Sophie Treyvaud (SUI)

Comunicación, Marketing, TV
Directora del departamento CMTV: 
Elena Grishina (RUS)
Coordinadora digital: 
Maria Ntanou (GRE)
Jefe de producción TV de la FIE: 
Barna Heder (HUN) 
Asistente de producción TV de la FIE: 
Svetlana Krasnokoutskaya (RUS)
Encargado de prensa: Serge Timacheff (USA)
Fotógrafo: Augusto Bizzi (ITA)

Diseño
Touchline 
(www.touchline.com)`,
    "mobileHtml": `<p>
                <b>Presidente</b>:<br> Alisher Usmanov (RUS)<br>
                <b>Secretario general</b>:<br> Emmanuel Katsiadakis (M.H.) (GRE)<br>
                <b>Secretaria tesorera</b>:<br> Ferial Nadira Salhi (ALG)</p>
                <p>
                <b>Vicepresidentes</b>:<br>
                Ana Pascu (M.H.) (ROU)<br>
                Donald Anthony (USA)<br>
                Wei Wang (CHN)<br></p>
                <p>
                <b>Miembros</b>:<br>
                Erika Aze (LAT)<br>
                Jacek Bierkowski (POL)<br>
                Velichka Hristeva (BUL)<br>
                Isabelle Lamour (FRA)<br>
                Yuki Ota (JPN)<br>
                Novak Perovic (RSA)<br>
                Oleg Peskov (KAZ)<br>
                Giorgio Scarso (ITA)<br>
                Bence Szabo (HUN)<br>
                Pascal Tesch (LUX)<br>
                Aldo Montano President of the FIE athletes commission (ITA)<br></p>

                <p>
                  <b>Presidente de la Confederación Africana de Esgrima</b>: <br>Mbagnick Ndiaye (SEN) <br>
                  <b>Presidente de la Confederación Panamericana de Esgrima</b>: <br>Vitaly Logvin (MEX) <br>
                  <b>Presidente de la Confederación Asiática de Esgrima</b>: <br>Celso L. Dayrit (M.H.) (PHI) <br>
                  <b>Presidente de la Confederación Europea de Esgrima</b>: <br>Stanislav Pozdnyakov (RUS)<br>
                  <b>Presidente de la Confederación Oceánica de Esgrima</b>: <br>Helen Smith (M.H.) (AUS)<br>
                </p>
                
                <h2>OFICINA CENTRAL DE LA FIE</h2>
                <p>
                <b>Directora general</b><br>
                Nathalie Rodriguez M.-H. (FRA)
                </p>

                <h2>Administración</h2>
                <p>
                <b>Directora administrativa</b>:<br> Elena Murdaca (ITA)<br>
                <b>Gestora de contabilidad</b>:<br> Margarita Berdoz (BUL) <br>
                <b>Asistente de dirección</b>:<br> Gabrielle Meylan (BRA)<br>
                <b>Asistente administrativa</b>:<br> Ylenia Murdaca (ITA)<br>
                </p>

                <h2>Deporte</h2>
                <p>
                <b>Director técnico y deportivo</b>:<br> Evgeny Tsoukhlo (RUS)<br>
                <b>Manager de la tecnología y de la administración del deporte</b>:<br> Natalia Bodrova (RUS)<br>
                <b>Manager de operaciones del deporte</b>:<br>Sophie Treyvaud (SUI) <br>
                </p>
                <h2>Comunicación, Marketing, TV</h2>
                <p>
                <b>Directora del departamento CMTV</b>:<br> Elena Grishina (RUS)<br>
                <b>Coordinadora digital</b>:<br> Maria Ntanou (GRE)<br>
                <b>Jefe de producción TV de la FIE</b>:<br> Barna Heder (HUN) <br>
                <b>Asistente de producción TV de la FIE</b>:<br> Svetlana Krasnokoutskaya (RUS)<br>
                <b>Encargado de prensa</b>:<br> Serge Timacheff (USA)<br>
                <b>Fotógrafo</b>:<br> Augusto Bizzi (ITA)<br>
                </p>

                <h2>Diseño</h2>
                <p>
                Touchline </b><br>
                (<a href="http://www.touchline.com" target="blank">www.touchline.com</a>)
                </p>`,
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Foreword",
      "index": 5,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg6.png",
      "zoom": null,
      "content": `
      <img id="fwdimg" class="halfScale" style="top:205px;left:523px;" src="/104/es/static/_content/6-img.jpg">
      <img id="fwdtitle" class="halfScaleR" style="top:486px;right:786px;" src="/104/es/static/_content/6-title.png">
      <img id="fwdarrow" class="halfScaleBR pointer" style="bottom:85px; right:21px;" onclick="Publish.nextPage();" src="/104/es/static/_content/6-next.jpg">

      <img id="6-text-1" class="halfScale" style="top:217px;left:201px;" src="/104/es/static/_content/6-text-1.png">
      <img id="6-text-2" class="halfScale" style="top:338px;left:201px;opacity:0;" src="/104/es/static/_content/6-text-2.png">

      <img id="6-cta-1" class="pointer halfScaleR" onclick="toggleText6(false);" style="top: 820px; right: 480px;" src="/104/es/static/_content/6-pg1a.jpg">
      <img id="6-cta-2" class="pointer halfScaleR" onclick="toggleText6(true);" style="top:821px; right:201px; opacity:0;" src="/104/es/static/_content/6-pg2a.jpg">
      <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
        <a href="http://www.fie.org/es" target="_blank"></a>
      </div>

      `,
      "script": `
        function onPageEnter(){
          var fwd = new TimelineMax();
          fwd.fromTo(idOf("fwdimg"), 0.5,{opacity:0}, {opacity:1},0.5)
             .fromTo(idOf("fwdtitle"), 0.3,{x:-100,opacity:0}, {x:0,opacity:1},"-=0.2")
             .fromTo(idOf("fwdarrow"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks},"+=0.3")
        }

        function toggleText6(bool){
          var text1 = idOf("6-text-1");
          var text2 = idOf("6-text-2");
          
          if(!bool && text1.style.opacity == "0"){
            TweenMax.fromTo(text1, 0.5, {opacity:0}, {opacity:1});
            TweenMax.fromTo(text2, 0.5, {opacity:1}, {opacity:0});
            TweenMax.fromTo(idOf("6-cta-1"), 0.5, {opacity:0}, {opacity:1});
            TweenMax.fromTo(idOf("6-cta-2"), 0.5, {opacity:1}, {opacity:0});
            TweenMax.fromTo(idOf("fwdimg"), 0.5, {opacity:0}, {opacity:1});
            TweenMax.fromTo(idOf("fwdtitle"), 0.5, {opacity:0}, {opacity:1});
          }else if(bool && text2.style.opacity == "0"){
            TweenMax.fromTo(text1, 0.5, {opacity:1}, {opacity:0});
            TweenMax.fromTo(text2, 0.5, {opacity:0}, {opacity:1});
            TweenMax.fromTo(idOf("6-cta-1"), 0.5, {opacity:1}, {opacity:0});
            TweenMax.fromTo(idOf("6-cta-2"), 0.5, {opacity:0}, {opacity:1});
            TweenMax.fromTo(idOf("fwdimg"), 0.5, {opacity:1}, {opacity:0});
            TweenMax.fromTo(idOf("fwdtitle"), 0.5, {opacity:1}, {opacity:0});
          }
        }
        function onPageLeave(){
          if(idOf("6-text-1").style.opacity == "0"){
            toggleText6(false);
          }
          removeContentLinks()
        }
      `,
      "searchText": `A STRONG GLOBAL COMMITMENT

      Queridos amigos,

      Estamos comenzando el 2018 y la celebración del 105° aniversario de la FIE con un fuerte compromiso global con nuestro deporte, beneficiándonos de los muchos programas, eventos y proyectos que la FIE y sus miembros están promoviendo y administrando. Mientras perseguimos con energía un ambicioso programa de eventos en la Copa del Mundo y el Gran Premio, al mismo tiempo estamos trabajando para ayudar a las nuevas federaciones y esgrimistas con actividades significativas tales como «Dona Tu Equipo de Esgrima». También seguimos esforzán–donos por hacer que nuestro deporte [ya] seguro sea aún más seguro, como por ejemplo, mediante la próxima implementación y aplicación de nuestra nueva correa de seguridad en las caretas. 

      Los Campeonatos del Mundo de Esgrima Junior y Cadete de este mes de abril tendrán lugar en Verona, un hermoso e histórico lugar situado al norte de Italia. Es aquí donde muchas de estas iniciativas y programas comenzarán a dar sus frutos. El año pasado, en Plovdiv, presentamos el programa «Dona Tu Equipo de Esgrima» y este año, en Verona, esperamos que los esgrimistas construyan, crezcan y continúen con su generosidad y donaciones humanitarias. El programa es perfecto para complementar la nobleza del deporte de la esgrima, ayudando a jóvenes atletas a ayudar a otros y aprender el verdadero significado de la deportividad. Además, los eventos de la categoría Cadete en los Campeonatos del Mundo servirán para clasificar la posición para los Juegos Olímpicos de la Juventud que tendrán lugar en el mes de octubre en Buenos Aires, Argentina. 
      
      También se llevará a cabo la segunda ronda de nuestra serie de tres eventos del Gran Premio, antes de los Campeonatos Junior y Cadete. Anaheim (USA), Budapest (HUN) y Seúl (KOR) organizarán competiciones de florete, espada y sable para nuestros esgrimistas de élite masculinos y femeninos. Ahora que estamos en la segunda parte del cuatrienio que se acerca a Tokio 2020, es emocionante ver cómo se están perfilando las clasificaciones y la aparición de nuevos talentos en la pista. 
      
      La FIE lo está haciendo bien y en gran medida es gracias a ustedes, nuestros esgrimistas, entrenadores, oficiales, federaciones, padres 
      y organizaciones. Quiero agradecerles su entusiasmo y dedicación, y les deseo lo mejor, dentro y fuera 
      de la pista. 
      
      Alisher Usmanov
      FIE Presidente`,
    "mobileHtml": `
    <h2>UN FUERTE COMPROMISO GLOBAL</h2>
    <img id="fwdimg" src="/104/es/static/_content/6-img.jpg">
    <p><b>Queridos amigos,</b></p>
    <p>
    Estamos comenzando el 2018 y la celebración del 105° aniversario de la FIE con un fuerte compromiso global con nuestro deporte, beneficiándonos de los muchos programas, eventos y proyectos que la FIE y sus miembros están promoviendo y administrando. Mientras perseguimos con energía un ambicioso programa de eventos en la Copa del Mundo y el Gran Premio, al mismo tiempo estamos trabajando para ayudar a las nuevas federaciones y esgrimistas con actividades significativas tales como «Dona Tu Equipo de Esgrima». También seguimos esforzán–donos por hacer que nuestro deporte [ya] seguro sea aún más seguro, como por ejemplo, mediante la próxima implementación y aplicación de nuestra nueva correa de seguridad en las caretas. 
    <p>
    Los Campeonatos del Mundo de Esgrima Junior y Cadete de este mes de abril tendrán lugar en Verona, un hermoso e histórico lugar situado al norte de Italia. Es aquí donde muchas de estas iniciativas y programas comenzarán a dar sus frutos. El año pasado, en Plovdiv, presentamos el programa «Dona Tu Equipo de Esgrima» y este año, en Verona, esperamos que los esgrimistas construyan, crezcan y continúen con su generosidad y donaciones humanitarias. El programa es perfecto para complementar la nobleza del deporte de la esgrima, ayudando a jóvenes atletas a ayudar a otros y aprender el verdadero significado de la deportividad. Además, los eventos de la categoría Cadete en los Campeonatos del Mundo servirán para clasificar la posición para los Juegos Olímpicos de la Juventud que tendrán lugar en el mes de octubre en Buenos Aires, Argentina.
    <p>
    También se llevará a cabo la segunda ronda de nuestra serie de tres eventos del Gran Premio, antes de los Campeonatos Junior y Cadete. Anaheim (USA), Budapest (HUN) y Seúl (KOR) organizarán competiciones de florete, espada y sable para nuestros esgrimistas de élite masculinos y femeninos. Ahora que estamos en la segunda parte del cuatrienio que se acerca a Tokio 2020, es emocionante ver cómo se están perfilando las clasificaciones y la aparición de nuevos talentos en la pista.
    <p>
    La FIE lo está haciendo bien y en gran medida es gracias a ustedes, nuestros esgrimistas, entrenadores, oficiales, federaciones, padres y organizaciones. Quiero agradecerles su entusiasmo y dedicación, y les deseo lo mejor, dentro y fuera de la pista. 
    <p><b>
    Alisher Usmanov <br>
    FIE Presidente</b></p>
    `
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 6,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg7.png",
      "zoom": null,
      "content": `
        <div class="contentLink" style="top:365px;left:480px;width:580px; height:40px;">
         <a href="http://www.absolutefencinggear.com/" target="_blank"></a>
       </div>
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "",
      "mobileHtml": `
      <a href="http://www.absolutefencinggear.com" target="_blank">

        <img id="absolute1img" src="/104/es/static/_mobile/pg7-absolute.png">
      </a>
      `
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 7,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg8.png",
      "zoom": null,
      "content": `
        <div class="contentLink" style="bottom:307px;left:30px;width:680px; height:50px;">
          <a href="http://www.fencewithfun.com" target="_blank"></a>
        </div>
        <div class="contentLink" style="bottom:47px;left:420px;width:240px; height:30px;">
          <a href="http://www.fencewithfun.com" target="_blank"></a>
        </div>
        <div class="contentLink" style="bottom:47px;left:84px;width:252px; height:30px;">
          <a href="mailto:info@fencewithfun.com" target="_blank"></a>
        </div>
      `,
      "script": ` 
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "",
      "mobileHtml": `
      <a href="http://www.fencewithfun.com" target="_blank">
        <img id="ad8img" src="/104/es/static/_mobile/pg8-fencewithfun.jpg">
      </a>
      `
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Algiers",
      "index": 8,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg9.png",
      "zoom": null,
      "content": `
        <img id="9-title" class="halfScale" src="/104/es/static/_content/9-title.png" alt="" style="top: 298px; left: 10px;">
        <img id="9-sub" class="halfScale" src="/104/es/static/_content/9-sub.png" alt="" style="top: 624px; left: 99px;">
        <img id="9-line" class="halfScale" src="/104/es/static/_content/9-line.png" alt="" style="top: 664px; left: 95px;">
        <img id="10-next" class="pointer halfScaleBR" style="bottom:178px; right:0px;" onclick="Publish.nextPage();" src="/104/es/static/_content/10-next.png">
      `,
      "script": `
        function onPageEnter() {
          page9Anim = new TimelineMax()
          page9Anim
            .fromTo(idOf("9-title"), 0.5,{x:-100, opacity:0}, {x:0, opacity:1},0.5)
            .fromTo(idOf("9-line"), 0.3,{opacity:0, y:50}, {y:0,opacity:1},"-=0.2")
            .fromTo(idOf("9-sub"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1},"+=0.1")
            .fromTo(idOf("10-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
        }

        function onPageLeave() {
          page9Anim.stop()
        }
      `,
      "searchText": `VOLPI DE ITALIA Y EL EQUIPO RUSO TRIUNFAN EN ARGELIA
      ALGIERS, ARGELIA 
2 AL 4 DE FEBRERO DE 2018
FLORETE FEMENINO`,
      "mobileHtml": `<h2>VOLPI DE ITALIA Y EL EQUIPO RUSO TRIUNFAN EN ARGELIA</h2>
      <p><b>
        ALGIERS, ALGELIA <br>
        2 AL 4 DE FEBRERO DE 2018 <br>
        FLORETE FEMENINO
      </b></p>`,
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Algiers",
      "index": 9,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg10.png",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img id="10-tw" class="halfScale pulse animatedpulse" src="/104/es/static/_content/10-tw.png" alt="" style="top:423px; left: 56px;">
        </a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
        <img id="10-fb" class="halfScale pulse animatedpulse" src="/104/es/static/_content/10-fb.png" alt="" style="top: 423px; left: 124px;">
        </a>
        <a href="http://fie.org/es/competitions/2018/129/results/rank" target="_blank">
        <img class="halfScale pulse animatedpulse" src="/104/es/static/_content/trophy1.png" alt="" style="top: 617px; left: 61px;">
        </a>
        <a href="http://fie.org/es/competitions/2018/563/results/rank" target="_blank">
        <img class="halfScale pulse animatedpulse" src="/104/es/static/_content/trophy1.png" alt="" style="top: 833px; left: 61px;">
        </a>
        <img id="10-arrow" class="pointer halfScaleBR" style="bottom:178px; right:0px;" onclick="Publish.nextPage();" src="/104/es/static/_content/10-next.png">
        <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
          <a href="http://www.fie.org/es" target="_blank"></a></div>
      `,
      "script": `
        function onPageEnter() {
          page10Anim = new TimelineMax()
          page10Anim
            .fromTo(idOf("10-arrow"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
            
        }

        function onPageLeave() {
          page10Anim.stop()
          removeContentLinks()
        }
      `,
      "searchText": `En el Campeonato del Mundo de Italia, la ganadora de la medalla de plata, Alice Volpi, se hizo este fin de semana con la medalla de oro en Algiers en la Copa del Mundo de Esgrima de Florete femenino en Argelia por Ooredoo.

      Cerca de 150 mujeres esgrimistas participaron en la prueba, que tuvo lugar en el Hacene Harcha Sports Arena. El equipo femenino ruso también ganó el oro en la prueba de florete por equipos, con 16 equipos internacionales compitiendo.
      
      Volpi se batió por el oro, en el último partido de la prueba individual femenina, contra su compañera de equipo, Erica Cipressa, ganando con una puntuación de 15-6. Cipressa logró finalmente vencer a la medallista de oro olímpica rusa y dos veces campeona mundial Inna Deriglazova en el partido de semifinales, 15-10. Volpi logró una estrecha victoria en la misma ronda contra la esgrimista polaca Hanna Lyczbinska, 15-14.
      
      En la prueba de equipo de florete femenino, Rusia superó a Francia en la ronda final, 42-32. Francia derrotó a Italia en la semifinal, 45-38, mientras que Rusia ganó un partido muy reñido contra Estados Unidos, 45-44. El equipo de Estados Unidos ganó la medalla de bronce sobre Italia, 45-34.
      
      La clasificación de las ocho mejores floretes individuales femeninos de la Copa del Mundo de Algeria, posiciona a Alice Volpi (ITA, oro), Erica Cipressa (ITA, plata), Inna Deriglazova (RUS, bronce), Hanna Lyczbinska (POL, bronce), Hyunhee Nam (COR), Chiara Cini (ITA), Nzingha Prescod (EEUU), y Elisabetta Bianchin (ITA).
      
      La clasificación de los ocho mejores equipos femeninos de florete, posiciona en primer lugar a Rusia (oro), seguido de Francia (plata), EEUU (bronce), Italia, Corea, Japón, Canadá y Alemania. 
      
      Se pueden encontrar los resultados completos de la competición individual aquí Y los resultados de la pruebas por equipos aquí`,

    "mobileHtml": `

    <img id="algiersimg" src="/104/es/static/_mobile/pg9-algiers.jpg">
    
    <p>En el Campeonato del Mundo de Italia, la ganadora de la medalla de plata, Alice Volpi, se hizo este fin de semana con la medalla de oro en Algiers en la Copa del Mundo de Esgrima de Florete femenino en Argelia por Ooredoo.</p>

    <p>Cerca de 150 mujeres esgrimistas participaron en la prueba, que tuvo lugar en el Hacene Harcha Sports Arena. El equipo femenino ruso también ganó el oro en la prueba de florete por equipos, con 16 equipos internacionales compitiendo.</p>
    
    <p>Volpi se batió por el oro, en el último partido de la prueba individual femenina, contra su compañera de equipo, Erica Cipressa, ganando con una puntuación de 15-6. Cipressa logró finalmente vencer a la medallista de oro olímpica rusa y dos veces campeona mundial Inna Deriglazova en el partido de semifinales, 15-10. Volpi logró una estrecha victoria en la misma ronda contra la esgrimista polaca Hanna Lyczbinska, 15-14.</p>

    <p>En la prueba de equipo de florete femenino, Rusia superó a Francia en la ronda final, 42-32. Francia derrotó a Italia en la semifinal, 45-38, mientras que Rusia ganó un partido muy reñido contra Estados Unidos, 45-44. El equipo de Estados Unidos ganó la medalla de bronce sobre Italia, 45-34.</p>

    <p>La clasificación de las ocho mejores floretes individuales femeninos de la Copa del Mundo de Algeria, posiciona a Alice Volpi (ITA, oro), Erica Cipressa (ITA, plata), Inna Deriglazova (RUS, bronce), Hanna Lyczbinska (POL, bronce), Hyunhee Nam (COR), Chiara Cini (ITA), Nzingha Prescod (EEUU), y Elisabetta Bianchin (ITA).</p>

    <p>La clasificación de los ocho mejores equipos femeninos de florete, posiciona en primer lugar a Rusia (oro), seguido de Francia (plata), EEUU (bronce), Italia, Corea, Japón, Canadá y Alemania. </p>

    <p>Se pueden encontrar los resultados completos de la competición individual aquí Y los resultados de la pruebas por equipos aquí </p>

    <p><a href="http://fie.org/es/competitions/2018/129/results/rank" target="_blank">Se pueden encontrar los resultados completos de la competición individual aquí</a></p>
    <p><a href="http://fie.org/es/competitions/2018/563/results/rank" target="_blank">Y los resultados de la pruebas por equipos aquí</p>`,
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Baltimore",
      "index": 10,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg11.png",
      "zoom": null,
      "content": `
        <img id="11-title" class="halfScale" src="/104/es/static/_content/11-title.png" alt="" style="top: 493px; left: 443px;">
        <img id="11-sub" class="halfScale" src="/104/es/static/_content/11-sub.png" alt="" style="top: 779px; left: 408px;">
        <img id="11-line" class="halfScale" src="/104/es/static/_content/9-line.png" alt="" style="top: 852px; left: 400px;">
        <img id="11-arrow" class="pointer halfScaleBR" style="bottom:178px; right:0;" onclick="Publish.nextPage();" src="/104/es/static/_content/10-next.png">
      `,
      "script": `
        function onPageEnter() {
          page11Anim = new TimelineMax()
          page11Anim
            .fromTo(idOf("11-title"), 0.5,{x:-100, opacity:0, }, {x:0, opacity:1},0.5)
            .fromTo(idOf("11-line"), 0.3,{opacity:0, y:50}, {y:0,opacity:1},"-=0.2")
            .fromTo(idOf("11-sub"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1},"+=0.1")
            .fromTo(idOf("11-arrow"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
        }

        function onPageLeave() {
          page11Anim.stop()
        }
      `,
      "searchText": `CRISCIO DE ITALIA Y EL EQUIPO DE FRANCIA GANAN ORO 
      BALTIMORE, EEUU 
      26 AL 28 DE ENERO DE 2018
      ESGRIMA FEMENINA`,
      "mobileHtml": `
        <h2>CRISCIO DE ITALIA Y EL EQUIPO DE FRANCIA GANAN ORO</h2>
        <p><b>BALTIMORE, EEUU <br>
        26 AL 28 DE ENERO DE 2018<br>
        ESGRIMA FEMENINA</b></p>
      `
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Baltimore",
      "index": 11,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg12.png",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img  class="halfScale pulse animatedpulse" src="/104/es/static/_content/10-tw.png" alt="" style="top:423px; left: 56px;">
        </a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScale pulse animatedpulse" src="/104/es/static/_content/10-fb.png" alt="" style="top: 423px; left: 124px;">
        </a>
        <a href="http://fie.org/es/competitions/2018/469/results/rank" target="_blank">
        <img class="halfScale pulse animatedpulse" src="/104/es/static/_content/trophy1.png" alt="" style="top: 628px; left: 61px;">
        </a>
        <a href="http://fie.org/es/competitions/2018/216/results/rank" target="_blank">
        <img class="halfScale pulse animatedpulse" src="/104/es/static/_content/trophy1.png" alt="" style="top: 829px; left: 61px;">
        </a>
        <img id="12-arrow" class="pointer halfScaleBR" style="bottom:178px; right:21px;" onclick="Publish.nextPage();" src="/104/es/static/_content/10-next.png">
        <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
          <a href="http://www.fie.org/es" target="_blank"></a></div>
      `,
      "script": `
        function onPageEnter() {
          page12Anim = new TimelineMax()
          page12Anim
            .fromTo(idOf("12-arrow"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
        }

        function onPageLeave() {
          page12Anim.stop()
          removeContentLinks()
        }
      `,
      "searchText": `
      Martina Criscio de Italia compitió con la mejor victoria de su carrera en la Copa del Mundo de Esgrima femenina de sable de Baltimore, llevándose el oro entre 170 esgrimistas mujeres de primer nivel de todo el mundo.

      Francia también se llevó el oro, ganando la competición femenina por equipos que contó con la participación de equipos de 19 países. El evento se llevó a cabo en el Centro de Convenciones de Baltimore.
      
      Criscio derrotó a Misaki Emura de Japón en la ronda final, por 15-11. Emura venció por poco a Charlotte Lembach de Francia en la semifinal, por 15-14, y logró una victoria por 15-14 frente a la medallista de oro olímpico de Rusia, Yana Egorian, en la ronda de 16. En la otra semifinal, Criscio derrotó a compañera de Lembach, Sarah Noutcha, por 15-10.
      
      En la competición de sable femenino por equipos, Francia se llevó el oro en el encuentro final frente a China, por 45-40. Ambos equipos obtuvieron victorias ajustadas en las semifinales, en que China venció a Hungría por 45-44 y Francia superó a Corea por 45-43. En la disputa por la medalla de bronce, Corea derrotó a Hungría por una sola estocada, por 45-44.
      
      La clasificación general de los ocho primeros puestos para mujeres en sable individual de Baltimore incluye a Martina Criscio (ITA, oro), Misaki Emura (JPN, plata), Charlotte Lembach (FRA, bronce), Sarah Noutcha (FRA, bronce), Dagmara Wozniak (USA), Sooyeon Choi (KOR), Olga Nikitina (RUS) y Alina Komashchuk (UKR).
      
      La clasificación de los ocho primeros puestos para mujeres en sable por equipos coloca a Francia (oro) en el primer lugar, seguido de China (plata), Corea (bronce), Hungría, EEUU, Italia, Rusia y España.

      Se pueden encontrar los resultados completos de la competición individual aquí
      Y los resultados de la pruebas por equipos aquí`,
      "mobileHtml": `

        <img id="baltimoreimg" src="/104/es/static/_mobile/pg11-baltimore.jpg">

        <p>Martina Criscio de Italia compitió con la mejor victoria de su carrera en la Copa del Mundo de Esgrima femenina de sable de Baltimore, llevándose el oro entre 170 esgrimistas mujeres de primer nivel de todo el mundo.</p>

        <p>Francia también se llevó el oro, ganando la competición femenina por equipos que contó con la participación de equipos de 19 países. El evento se llevó a cabo en el Centro de Convenciones de Baltimore.</p>

        <p>Criscio derrotó a Misaki Emura de Japón en la ronda final, por 15-11. Emura venció por poco a Charlotte Lembach de Francia en la semifinal, por 15-14, y logró una victoria por 15-14 frente a la medallista de oro olímpico de Rusia, Yana Egorian, en la ronda de 16. En la otra semifinal, Criscio derrotó a compañera de Lembach, Sarah Noutcha, por 15-10.</p>

        <p>En la competición de sable femenino por equipos, Francia se llevó el oro en el encuentro final frente a China, por 45-40. Ambos equipos obtuvieron victorias ajustadas en las semifinales, en que China venció a Hungría por 45-44 y Francia superó a Corea por 45-43. En la disputa por la medalla de bronce, Corea derrotó a Hungría por una sola estocada, por 45-44. </p>

        <p>La clasificación general de los ocho primeros puestos para mujeres en sable individual de Baltimore incluye a Martina Criscio (ITA, oro), Misaki Emura (JPN, plata), Charlotte Lembach (FRA, bronce), Sarah Noutcha (FRA, bronce), Dagmara Wozniak (USA), Sooyeon Choi (KOR), Olga Nikitina (RUS) y Alina Komashchuk (UKR).</p>

        <p>La clasificación de los ocho primeros puestos para mujeres en sable por equipos coloca a Francia (oro) en el primer lugar, seguido de China (plata), Corea (bronce), Hungría, EEUU, Italia, Rusia y España.</p>

        <p><a href="http://fie.org/es/competitions/2018/469/results/rank" target="_blank">Se pueden encontrar los resultados completos de la competición individual aquí</a></p>
        <p><a href="http://fie.org/es/competitions/2018/216/results/rank" target="_blank">Y los resultados de la pruebas por equipos aquí</a></p>
      `
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Barcelona",
      "index": 12,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg13.png",
      "zoom": null,
      "content": `
        <img id="13-arrow" class="pointer halfScaleBR" style="bottom:178px; right:0px;" onclick="Publish.nextPage();" src="/104/es/static/_content/10-next.png">
        <img id="13-title" class="halfScale" src="/104/es/static/_content/13-title.png" alt="" style="top: 402px; left: 16px;">
        <img id="13-sub" class="halfScale" src="/104/es/static/_content/13-sub.png" alt="" style="top: 760px; left: 53px;">
        <img id="13-line" class="halfScale" src="/104/es/static/_content/9-line.png" alt="" style="top: 760px; left: 80px;">
      `,
      "script": `
        function onPageEnter() {
          page13Anim = new TimelineMax()
          page13Anim
            .fromTo(idOf("13-title"), 0.5,{x:-100, opacity:0, }, {x:0, opacity:1},0.5)
            .fromTo(idOf("13-line"), 0.3,{opacity:0, y:50}, {y:0,opacity:1},"-=0.2")
            .fromTo(idOf("13-sub"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1},"+=0.1")
            .fromTo(idOf("13-arrow"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
        }

        function onPageLeave() {
          page13Anim.stop()
        }
      `,
      "searchText": `ZHU DE CHINA Y EL EQUIPO RUSO SALEN VICTORIOSOS

      BARCELONA, ESPAÑA   
      9 AL 11 DE FEBRERO DE 2018
      ESPADA FEMENINA
        `,
      "mobileHtml": `<h2>ZHU DE CHINA Y EL EQUIPO RUSO SALEN VICTORIOSOS</h2>

        <p><b>BARCELONA, ESPAÑA  <br>
        9 AL 11 DE FEBRERO DE 2018 <br>
        ESPADA FEMENINA</b></p>`
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Barcelona",
      "index": 13,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg14.png",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img  class="halfScale pulse animatedpulse" src="/104/es/static/_content/10-tw.png" alt="" style="top:423px; left: 56px;">
        </a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScale pulse animatedpulse" src="/104/es/static/_content/10-fb.png" alt="" style="top: 423px; left: 124px;">
        </a>
        <a href="http://fie.org/es/competitions/2018/92/results/rank" target="_blank">
        <img class="halfScale pulse animatedpulse" src="/104/es/static/_content/trophy1.png" alt="" style="top: 656px; left: 61px;">
        </a>
        <a href="http://fie.org/es/competitions/2018/750/results/rank" target="_blank">
        <img class="halfScale pulse animatedpulse" src="/104/es/static/_content/trophy1.png" alt="" style="top: 860px; left: 61px;">
        </a>
        <img id="14-arrow" class="pointer halfScaleBR" style="bottom:178px; right:21px;" onclick="Publish.nextPage();" src="/104/es/static/_content/10-next.png">
        <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
          <a href="http://www.fie.org/es" target="_blank"></a></div>
      `,
      "script": `
        function onPageEnter() {
          page14Anim = new TimelineMax()
          page14Anim
            .fromTo(idOf("14-arrow"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
        }

        function onPageLeave() {
          page14Anim.stop()
          removeContentLinks
        }
      `,
      "searchText": `
      En su mejor resultado profesional, la esgrimista china Mingye Zhu se llevó el oro en la histórica Copa del Mundo de Esgrima de espada “Ciutat de Barcelona” en España.

      El equipo ruso femenino de espada también ganó el oro en el prueba de espada femenina por equipos. Celebrado en el Institut Nacional d'Educacio Fisica de Catalunya (INEFC), una instalación de los Juegos Olímpicos y Paralímpicos de Barcelona de 1992. Alrededor de unas 250 mujeres de todo el mundo compitieron individualmente, así como más de 25 equipos nacionales e internacionales.
      
      La china Mingye Zhu derrotó a la rusa Tatyana Andryushina, 15-7, en la ronda final de la prueba de espada individual femenina, después de ganar contra la coreana Young Mi Kang en las semifinales, 15-11. Andryushina eliminó a la ucraniana Olena Kryvytska,15-5, en la misma ronda. Varias competidoras de alto nivel fueron eliminadas en los cuartos de final, incluyendo a la campeona mundial Julia Beljajeva (EST), la campeona mundial Tatyana Gudkova (RUS), y la dos veces campeona mundial y medallista de plata olímpica Rossella Fiamingo (ITA).
      
      En la prueba femenina de espada por equipos, Rusia venció a Italia 35-25 en el último partido. Italia derrotó a Rumanía en la semifinal, 39-29, mientras que Rusia venció a EEUU en la misma ronda por prioridad, 32-32. EEUU ganó la medalla de bronce contra Rumanía, 28-20.
      
      Entre los ocho primeros puestos de la clasificación general individual femenina de espadas de Barcelona se encuentran Mingye Zhu (CHN, oro), Tatyana Andryushina (RUS, plata), Young Mi Kang (KOR, bronce), Olena Kryvytska (UKR, bronce), Julia Beljajeva (EST), Tatyana Gudkova (RUS), Rossella Fiamingo (ITA) y Hyojung Jung (KOR).
      
      Las primeras ocho clasificaciones de equipos femeninos de espada colocan en primer lugar a Rusia (oro), seguidas por Italia (plata), EEUU (bronce), Rumanía, Estonia, Francia, China y Hong Kong.
Se pueden encontrar los resultados completos de la competición individual aquí
Y los resultados de la pruebas por equipos aquí`,
    "mobileHtml": `

      <img id="barcelonaimg" src="/104/es/static/_mobile/pg13-barcelona.jpg">

      <p>En su mejor resultado profesional, la esgrimista china Mingye Zhu se llevó el oro en la histórica Copa del Mundo de Esgrima de espada “Ciutat de Barcelona” en España.</p>

      <p>El equipo ruso femenino de espada también ganó el oro en el prueba de espada femenina por equipos. Celebrado en el Institut Nacional d'Educacio Fisica de Catalunya (INEFC), una instalación de los Juegos Olímpicos y Paralímpicos de Barcelona de 1992. Alrededor de unas 250 mujeres de todo el mundo compitieron individualmente, así como más de 25 equipos nacionales e internacionales.</p>

      <p>La china Mingye Zhu derrotó a la rusa Tatyana Andryushina, 15-7, en la ronda final de la prueba de espada individual femenina, después de ganar contra la coreana Young Mi Kang en las semifinales, 15-11. Andryushina eliminó a la ucraniana Olena Kryvytska,15-5, en la misma ronda. Varias competidoras de alto nivel fueron eliminadas en los cuartos de final, incluyendo a la campeona mundial Julia Beljajeva (EST), la campeona mundial Tatyana Gudkova (RUS), y la dos veces campeona mundial y medallista de plata olímpica Rossella Fiamingo (ITA).</p>

      <p>En la prueba femenina de espada por equipos, Rusia venció a Italia 35-25 en el último partido. Italia derrotó a Rumanía en la semifinal, 39-29, mientras que Rusia venció a EEUU en la misma ronda por prioridad, 32-32. EEUU ganó la medalla de bronce contra Rumanía, 28-20.</p>

      <p>Entre los ocho primeros puestos de la clasificación general individual femenina de espadas de Barcelona se encuentran Mingye Zhu (CHN, oro), Tatyana Andryushina (RUS, plata), Young Mi Kang (KOR, bronce), Olena Kryvytska (UKR, bronce), Julia Beljajeva (EST), Tatyana Gudkova (RUS), Rossella Fiamingo (ITA) y Hyojung Jung (KOR).</p>

      <p>Las primeras ocho clasificaciones de equipos femeninos de espada colocan en primer lugar a Rusia (oro), seguidas por Italia (plata), EEUU (bronce), Rumanía, Estonia, Francia, China y Hong Kong.</p>

      <p><a href="http://fie.org/es/competitions/2018/92/results/rank" target="_blank">Se pueden encontrar los resultados completos de la competición individual aquí</a></p>
      <p><a href="http://fie.org/es/competitions/2018/750/results/rank" target="_blank">Y los resultados de la pruebas por equipos aquí</a></p>`,
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 14,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg15.jpg",
      "zoom": null,
      "content": `
      <div class="contentLink" style="bottom:98px;left:130px;width:227px; height:30px;">
         <a href="https://uhlmann-fechtsport.com" target="_blank"></a>
       </div>
       <div class="contentLink" style="bottom:98px;left:380px;width:330px; height:30px;">
         <a href="https://www.facebook.com/UhlmannFechtsport" target="_blank"></a>
       </div>
       <div class="contentLink" style="bottom:98px;left:733px;width:324px; height:30px;">
         <a href="https://www.instagram.com/Uhlmann.Fencing" target="_blank"></a>
       </div>
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "",
      "mobileHtml": `
      <a href="https://uhlmann-fechtsport.com" target="_blank">
        <img id="ad15img" src="/104/es/static/_mobile/pg15-uhlmann.jpg">
      </a>
      `
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 15,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg16.png",
      "zoom": null,
      "content": `
       <div class="contentLink" style="bottom:95px;right:464px;width:240px; height:30px;">
         <a href="mailto:jason@jiangfencing.com" target="_blank"></a>
       </div>
       <div class="contentLink" style="bottom:125px;right:495px;width:223px; height:25px;">
         <a href="http://www.jiangfencing.com" target="_blank"></a>
       </div>
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "",
      "mobileHtml": `
      <a href="http://www.jiangfencing.com" target="_blank">
        <img id="ad16img" src="/104/es/static/_mobile/pg16-jiangfencing.jpg">
      </a>
      `
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Bonn",
      "index": 16,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg17.png",
      "zoom": null,
      "content": `
        <img id="17-arrow" class="pointer halfScaleBR" style="bottom:178px; right:0px;" onclick="Publish.nextPage();" src="/104/es/static/_content/10-next.png">
        <img id="17-title" class="halfScale" src="/104/es/static/_content/17-title.png" alt="" style="top: 17px; left: 17px;">
        <img id="17-sub" class="halfScale" src="/104/es/static/_content/17-sub.png" alt="" style="top: 387px; left: 98px;">
        <img id="17-line" class="halfScale" src="/104/es/static/_content/9-line.png" alt="" style="top: 455px; left: 88px;">
      `,
      "script": `
        function onPageEnter() {
          page17Anim = new TimelineMax()
          page17Anim
            .fromTo(idOf("17-title"), 0.5,{x:-100, opacity:0, }, {x:0, opacity:1},0.5)
            .fromTo(idOf("17-line"), 0.3,{opacity:0, y:50}, {y:0,opacity:1},"-=0.2")
            .fromTo(idOf("17-sub"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1},"+=0.1")
            .fromTo(idOf("17-arrow"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
            
        }

        function onPageLeave() {
          page17Anim.stop()
        }
      `,
      "searchText": `
      CHEREMISNOV DE RUSIA Y EL EQUIPO DE EEUU GANAN EL ORO 
      BONN, ALEMANIA
      9 AL 11 DE FEBRERO DE 2018
      FLORETE MASCULINO`,
      "mobileHtml": `
        <h2>CHEREMISNOV DE RUSIA Y EL EQUIPO DE EEUU GANAN EL ORO </h2>
        <p><b>
        BONN, ALEMANIA <br>
        9 AL 11 DE FEBRERO DE 2018 <br>
        FLORETE MASCULINO</b></p>
      `,
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Bonn",
      "index": 17,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg18.png",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img  class="halfScale pulse animatedpulse" src="/104/es/static/_content/10-tw.png" alt="" style="top:423px; left: 56px;">
        </a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScale pulse animatedpulse" src="/104/es/static/_content/10-fb.png" alt="" style="top: 423px; left: 124px;">
        </a>
        <a href="http://fie.org/es/competitions/2018/138/results/rank" target="_blank">
        <img class="halfScale pulse animatedpulse" src="/104/es/static/_content/trophy1.png" alt="" style="top: 623px; left: 61px;">
        </a>
        <a href="http://fie.org/es/competitions/2018/761/results/rank" target="_blank">
        <img class="halfScale pulse animatedpulse" src="/104/es/static/_content/trophy1.png" alt="" style="top: 830px; left: 61px;">
        </a>
        <img id="18-arrow" class="pointer halfScaleBR" style="bottom:178px; right:21px;" onclick="Publish.nextPage();" src="/104/es/static/_content/10-next.png">
        <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
          <a href="http://www.fie.org/es" target="_blank"></a></div>
      `,
      "script": `
        function onPageEnter() {
          page18Anim = new TimelineMax()
          page18Anim
            .fromTo(idOf("18-arrow"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
        }

        function onPageLeave() {
          page18Anim.stop()
          removeContentLinks()
        }
      `,
      "searchText": `El campeón mundial ruso Alexey Cheremisinov se llevó los máximos honores en Bonn, ganando la Copa del Mundo Masculino de Esgrima de Löwe von Bonn. 

      El equipo de florete masculino de EEUU también se llevó el oro, ganando la prueba de florete masculino por equipos. La Copa del Mundo atrajo a más de 250 esgrimistas internacionales de florete masculino, así como a 27 equipos de todo el mundo.
      
      Cheremisinov eliminó al número dos del mundo y medallista olímpico de plata Alexander Massialas (EEUU) en la final de la prueba individual masculina de florete, 15-8. Massialas derrotó al francés Jeremy Cadot en la semifinal, 15-11, mientras que Cheremisinov venció al italiano Guillaume Bianchi en la misma ronda, 15-8.
      
      En la prueba masculina de florete por equipos, EEUU venció a Corea, 45-32, después de derrotar a los rusos en la semifinal, 45-37. Corea venció a Francia en la misma ronda, 45-36. En el partido por la medalla de bronce, Francia derrotó por poco a Rusia, 44-43.
      
      La clasificación de los ocho mejores floretes individuales masculinos de la Copa Mundial de Bonn, posiciona a Alexey Cheremisinov (RUS, oro), Alexander Massialas (EEUU, Plata), Guillaume Bianchi (ITA, bronce), Jeremy Cadot (FRA, bronce), Taegyu Ha (COR), Marcus Mempstead (GBR), Lorenzo Nista (ITA) y Andrzej Rzadkowski (POL).
      
      La clasificación de los ocho mejores equipos masculinos de florete posiciona, en primer lugar a EEUU (Oro), seguido de Corea (plata), Francia (bronce), Rusia, Italia, Japón, Alemania y China.`,
      "mobileHtml": `

        <img id="bonnimg" src="/104/es/static/_mobile/pg17-bonn.jpg">

        <p>El campeón mundial ruso Alexey Cheremisinov se llevó los máximos honores en Bonn, ganando la Copa del Mundo Masculino de Esgrima de Löwe von Bonn. </p>
        <p>El equipo de florete masculino de EEUU también se llevó el oro, ganando la prueba de florete masculino por equipos. La Copa del Mundo atrajo a más de 250 esgrimistas internacionales de florete masculino, así como a 27 equipos de todo el mundo.</p>

        <p>Cheremisinov eliminó al número dos del mundo y medallista olímpico de plata Alexander Massialas (EEUU) en la final de la prueba individual masculina de florete, 15-8. Massialas derrotó al francés Jeremy Cadot en la semifinal, 15-11, mientras que Cheremisinov venció al italiano Guillaume Bianchi en la misma ronda, 15-8.</p>

        <p>En la prueba masculina de florete por equipos, EEUU venció a Corea, 45-32, después de derrotar a los rusos en la semifinal, 45-37. Corea venció a Francia en la misma ronda, 45-36. En el partido por la medalla de bronce, Francia derrotó por poco a Rusia, 44-43.</p> 
        <p>La clasificación de los ocho mejores floretes individuales masculinos de la Copa Mundial de Bonn, posiciona a Alexey Cheremisinov (RUS, oro), Alexander Massialas (EEUU, Plata), Guillaume Bianchi (ITA, bronce), Jeremy Cadot (FRA, bronce), Taegyu Ha (COR), Marcus Mempstead (GBR), Lorenzo Nista (ITA) y Andrzej Rzadkowski (POL).</p>

        <p>La clasificación de los ocho mejores equipos masculinos de florete posiciona, en primer lugar a EEUU (Oro), seguido de Corea (plata), Francia (bronce), Rusia, Italia, Japón, Alemania y China.</p>

        <p><a href="http://fie.org/es/competitions/2018/138/results/rank" target="_blank">Se pueden encontrar los resultados completos de la competición individual aquí</a></p>
        <p><a href="http://fie.org/es/competitions/2018/761/results/rank" target="_blank">Y los resultados de la pruebas por equipos aquí</a></p>
        `,
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "La Habana",
      "index": 18,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg19.png",
      "zoom": null,
      "content": `
        <img id="19-next" class="pointer halfScaleBR" style="bottom:178px; right:0px;" onclick="Publish.nextPage();" src="/104/es/static/_content/10-next.png">
        <img id="19-title" class="halfScale" src="/104/es/static/_content/19-title.png" alt="" style="top: 17px; left: 17px;">
        <img id="19-sub" class="halfScale" src="/104/es/static/_content/19-sub.png" alt="" style="top: 405px; left: 208px;">
        <img id="19-line" class="halfScale" src="/104/es/static/_content/9-line.png" alt="" style="top: 472px; left: 201px;">
      `,
      "script": `
        function onPageEnter() {
          page19Anim = new TimelineMax()
          page19Anim
            .fromTo(idOf("19-title"), 0.5,{x:-100, opacity:0, }, {x:0, opacity:1},0.5)
            .fromTo(idOf("19-line"), 0.3,{opacity:0, y:50}, {y:0,opacity:1},"-=0.2")
            .fromTo(idOf("19-sub"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1},"+=0.1")
            .fromTo(idOf("19-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
        }

        function onPageLeave() {
          page19Anim.stop()
        }
      `,
      "searchText": `LA FRANCESA VITALIS Y EL EQUIPO DE COREA GANAN EL ORO

      LA HABANA, CUBA 
19 AL 21 DE ENERO DE 2018
ESPADA FEMENINA
        `,
      "mobileHtml": `
        <h2>LA FRANCESA VITALIS Y EL EQUIPO DE COREA GANAN EL ORO</h2>

        <p><b>LA HABANA, CUBA <br>
        19 AL 21 DE ENERO DE 2018<br>
        ESPADA FEMENINA</b></p>
      `
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "La Habana",
      "index": 19,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg20.png",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img  class="halfScale pulse animatedpulse" src="/104/es/static/_content/10-tw.png" alt="" style="top:423px; left: 56px;">
        </a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScale pulse animatedpulse" src="/104/es/static/_content/10-fb.png" alt="" style="top: 423px; left: 124px;">
        </a>
        <a href="http://fie.org/es/competitions/2018/85/results/rank" target="_blank">
        <img class="halfScale pulse animatedpulse" src="/104/es/static/_content/trophy1.png" alt="" style="top: 623px; left: 61px;">
        </a>
        <a href="http://fie.org/es/competitions/2018/822/results/rank" target="_blank">
        <img class="halfScale pulse animatedpulse" src="/104/es/static/_content/trophy1.png" alt="" style="top: 830px; left: 61px;">
        </a>
        <img id="20-arrow" class="pointer halfScaleBR" style="bottom:178px; right:21px;" onclick="Publish.nextPage();" src="/104/es/static/_content/10-next.png">
        <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
          <a href="http://www.fie.org/es" target="_blank"></a></div>
      `,
      "script": `
        function onPageEnter() {
          page20Anim = new TimelineMax()
          page20Anim
            .fromTo(idOf("20-arrow"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
        }

        function onPageLeave() {
          page20Anim.stop()
          removeContentLinks()
        }
      `,
      "searchText": `La francesa Vitalis ganó el oro en Cuba y ganó la prueba individual de espada femenina en la Copa del Mundo de La Habana.

      En la prueba por equipos, Corea ganó la medalla de oro. La prueba incluyó 17 equipos internacionales y aproximadamente 150 esgrimistas individuales.
      
      Vitalis ganó la ronda final contra el coreano Hyein Lee, por 15 a 12, tras derrotar a la medallista de bronce olímpica, Yiwen Sun, por un solo toque, por 15-14, en las semifinales. En la misma ronda, Lee ganó a Man Wai Vivian Kong, de Hong Kong en otro ajustado match, por 15-14.
      
      En la prueba femenina de espada por equipos, Corea se impuso a Rusia en el match final, por 45-34. Corea superó a China, por 45-36, en las semifinales, aunque Rusia superó a Italia, por 28-23. China consiguió la medalla de bronce, tras vencer a Italia, por 38-30.
      
      La clasificación general de los ocho mejores en espada femenina de la Copa del Mundo de La Habana incluyen a Coraline Vitalis (FRA, oro), Hyein Lee (KOR, planta), Man Wai Vivian Kong (HKG, bronce), Yiwen Sun (CHN, bronce), Young Mi Kang (KOR), Giulia Rizzi (ITA), Ricarda Multerer (GER) y Olga Kochneva (RUS).
      
      La clasificación de los ocho mejores equipos coloca a Corea (oro) el primero, seguido por Rusia (plata), China (bronce), Italia, Polonia, Francia, Estonia y Alemania.
      
      Los resultados completos de la competición individual.
Se pueden encontrar los resultados completos de la competición individual aquí
Y los resultados de la pruebas por equipos aquí`,
    "mobileHtml": `

      <img id="havanaimg" src="/104/es/static/_mobile/pg19-havana.jpg">

      <p>La francesa Vitalis ganó el oro en Cuba y ganó la prueba individual de espada femenina en la Copa del Mundo de La Habana.</p>

      <p>En la prueba por equipos, Corea ganó la medalla de oro. La prueba incluyó 17 equipos internacionales y aproximadamente 150 esgrimistas individuales.</p>

      <p>Vitalis ganó la ronda final contra el coreano Hyein Lee, por 15 a 12, tras derrotar a la medallista de bronce olímpica, Yiwen Sun, por un solo toque, por 15-14, en las semifinales. En la misma ronda, Lee ganó a Man Wai Vivian Kong, de Hong Kong en otro ajustado match, por 15-14.
      </p>
      <p>En la prueba femenina de espada por equipos, Corea se impuso a Rusia en el match final, por 45-34. Corea superó a China, por 45-36, en las semifinales, aunque Rusia superó a Italia, por 28-23. China consiguió la medalla de bronce, tras vencer a Italia, por 38-30.
      </p>

      <p>La clasificación general de los ocho mejores en espada femenina de la Copa del Mundo de La Habana incluyen a Coraline Vitalis (FRA, oro), Hyein Lee (KOR, planta), Man Wai Vivian Kong (HKG, bronce), Yiwen Sun (CHN, bronce), Young Mi Kang (KOR), Giulia Rizzi (ITA), Ricarda Multerer (GER) y Olga Kochneva (RUS).</p>

      <p>La clasificación de los ocho mejores equipos coloca a Corea (oro) el primero, seguido por Rusia (plata), China (bronce), Italia, Polonia, Francia, Estonia y Alemania.</p>
      <p>Los resultados completos de la competición individual.
      </p>

      <p><a href="http://fie.org/es/competitions/2018/85/results/rank" target="_blank">Se pueden encontrar los resultados completos de la competición individual aquí</a></p>
      <p><a href="http://fie.org/es/competitions/2018/822/results/rank" target="_blank">Y los resultados de la pruebas por equipos aquí</a></p>
    `
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 20,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg21.png",
      "zoom": null,
      "content": `
        <div class="contentLink" style="top:315px;left:78px;width:470px; height:200px;">
         <a href="http://www.blaise-freres.fr/fr/" target="_blank"></a>
       </div>
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "",
      "mobileHtml": `
      <img id="ad21img" src="/104/es/static/_mobile/pg21-blaise.jpg">
      `
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 21,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg22.jpg",
      "zoom": null,
      "content": `
        <div class="contentLink" style="bottom:133px;left:250px;width:1084px; height:80px;">
         <a href="http://www.blue-gauntlet.com" target="_blank"></a>
       </div>
       <div class="contentLink" style="bottom:73px;left:521px;width:690px; height:47px;">
         <a href="mailto:service@blue-gauntletservice.com" target="_blank"></a>
       </div>
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "",
      "mobileHtml": `
      <a href="http://www.blue-gauntlet.com" target="_blank">
        <img id="ad22img" src="/104/es/static/_mobile/pg22-bluegauntlet.jpg">
      </a>
      `
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Heidenheim",
      "index": 22,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg23.png",
      "zoom": null,
      "content": `
        <img id="23-arrow" class="pointer halfScaleBR" style="bottom:178px; right:0px;" onclick="Publish.nextPage();" src="/104/es/static/_content/10-next.png">
        <img id="23-title" class="halfScale" src="/104/es/static/_content/23-title.png" alt="" style="top: 406px; left: 372px;">
        <img id="23-sub" class="halfScale" src="/104/es/static/_content/23-sub.png" alt="" style="top: 711px; left: 793px;">
        <img id="23-line" class="halfScale" src="/104/es/static/_content/9-line.png" alt="" style="top: 780px; left: 785px;">
      `,
      "script": `
        function onPageEnter() {
          page23Anim = new TimelineMax()
          page23Anim
            .fromTo(idOf("23-title"), 0.5,{x:-100, opacity:0, }, {x:0, opacity:1},0.5)
            .fromTo(idOf("23-line"), 0.3,{opacity:0, y:50}, {y:0,opacity:1},"-=0.2")
            .fromTo(idOf("23-sub"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1},"+=0.1")
            .fromTo(idOf("23-arrow"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
        }

        function onPageLeave() {
          page23Anim.stop()
        }
      `,
      "searchText": `MINOBE DE JAPÓN Y EL EQUIPO DE COREA LOGRAN EL ORO

      HEIDENHEIM, ALEMANIA 
26  AL 28 DE ENERO DE 2018
ESPADA MASCULINA
      `,
      "mobileHtml": `
        <h2>MINOBE DE JAPÓN Y EL EQUIPO DE COREA LOGRAN EL ORO</h2>

        <p><b>HEIDENHEIM, ALEMANIA <br>
        26  AL 28 DE ENERO DE 2018 <br>
        ESPADA MASCULINA</b></p>
      `,
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Heidenheim",
      "index": 23,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg24.png",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img  class="halfScale pulse animatedpulse" src="/104/es/static/_content/10-tw.png" alt="" style="top:423px; left: 56px;">
        </a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScale pulse animatedpulse" src="/104/es/static/_content/10-fb.png" alt="" style="top: 423px; left: 124px;">
        </a>
        <a href="http://fie.org/es/competitions/2018/98/results/rank" target="_blank">
        <img class="halfScale pulse animatedpulse" src="/104/es/static/_content/trophy1.png" alt="" style="top: 623px; left: 61px;">
        </a>
        <a href="http://fie.org/es/competitions/2018/454/results/rank" target="_blank">
        <img class="halfScale pulse animatedpulse" src="/104/es/static/_content/trophy1.png" alt="" style="top: 830px; left: 61px;">
        </a>
        <img id="24-arrow" class="pointer halfScaleBR" style="bottom:178px; right:21px;" onclick="Publish.nextPage();" src="/104/es/static/_content/10-next.png">
        <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
          <a href="http://www.fie.org/es" target="_blank"></a></div>
      `,
      "script": `
        function onPageEnter() {
          page24Anim = new TimelineMax()
          page24Anim
            .fromTo(idOf("24-arrow"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
        }

        function onPageLeave() {
          page24Anim.stop()
          removeContentLinks()
        }
      `,
      "searchText": `Kazuyasu Minobe de Japón logró la medalla de oro este fin de semana en la Copa del Mundo de Esgrima de espada masculina Heidenheimer Pokal en Alemania, superando a más de 300 competidores.

      El equipo masculino coreano también ganó oro en el evento, que contó con la participación de equipos de más de 30 países. El evento se llevó a cabo en el Congress Centrum de Heidenheim.
      
      Minobe derrotó a Bogdan Nikishin de Ucrania en el encuentro final, por 15-13. Nikishin había ganado el mismo eventos dos veces anteriormente (2013, 2014). Superó a Gabriele Cimini de Italia en la semifinal, por 15-8, mientras que Minobe derrotó a Vadim Anokhin de Rusia, por 15-9, en la misma ronda. El espadista japonés también obtuvo una notable victoria en los cuartos de final, derrotando al campeón olímpico coreano Sangyoung Park, por 15-11.
      
      En el evento de espada masculina por equipos, Corea obtuvo la victoria frente a Francia en la final, por 45-41. Anteriormente, Corea derrotó al equipo masculino suizo en las semifinales, por 45-33, mientras que Francia derrotó a Rusia, por 45-35. Suiza se llevó a casa la medalla de bronce tras derrotar a Rusia por el tercer lugar, por 45-35.
      
      La clasificación general de los ocho primeros puestos para varones en espada individual de Heidenheim incluye a Kazuyasu Minobe (JPN, oro), Bogdan Nikishin (UKR, plata), Vadim Anokhin (RUS, bronce), Gabriele Cimini (ITA, bronce), Marco Fichera (ITA), Sangyoung Park (KOR), Youngjun Kweon (KOR) y Jongkwan Na (KOR).
      
      La clasificación de los ocho primeros puestos para varones en espada por equipos coloca a Corea (oro) en primer lugar, seguido de Francia (plata), Suiza (bronce), Rusia, República Checa, Italia, Ucrania y Japón. 
      
      Se pueden encontrar los resultados completos de la competición individual aquí
      
      Y los resultados de la pruebas por equipos aquí`,
      "mobileHtml": `

        <img id="heidenheimimg" src="/104/es/static/_mobile/pg23-heidenheim.jpg">

        <p>Kazuyasu Minobe de Japón logró la medalla de oro este fin de semana en la Copa del Mundo de Esgrima de espada masculina Heidenheimer Pokal en Alemania, superando a más de 300 competidores.</p>

        <p>El equipo masculino coreano también ganó oro en el evento, que contó con la participación de equipos de más de 30 países. El evento se llevó a cabo en el Congress Centrum de Heidenheim.</p>

        <p>Minobe derrotó a Bogdan Nikishin de Ucrania en el encuentro final, por 15-13. Nikishin había ganado el mismo eventos dos veces anteriormente (2013, 2014). Superó a Gabriele Cimini de Italia en la semifinal, por 15-8, mientras que Minobe derrotó a Vadim Anokhin de Rusia, por 15-9, en la misma ronda. El espadista japonés también obtuvo una notable victoria en los cuartos de final, derrotando al campeón olímpico coreano Sangyoung Park, por 15-11.</p>

        <p>En el evento de espada masculina por equipos, Corea obtuvo la victoria frente a Francia en la final, por 45-41. Anteriormente, Corea derrotó al equipo masculino suizo en las semifinales, por 45-33, mientras que Francia derrotó a Rusia, por 45-35. Suiza se llevó a casa la medalla de bronce tras derrotar a Rusia por el tercer lugar, por 45-35.</p>

        <p>La clasificación general de los ocho primeros puestos para varones en espada individual de Heidenheim incluye a Kazuyasu Minobe (JPN, oro), Bogdan Nikishin (UKR, plata), Vadim Anokhin (RUS, bronce), Gabriele Cimini (ITA, bronce), Marco Fichera (ITA), Sangyoung Park (KOR), Youngjun Kweon (KOR) y Jongkwan Na (KOR).
</p>

<p>La clasificación de los ocho primeros puestos para varones en espada por equipos coloca a Corea (oro) en primer lugar, seguido de Francia (plata), Suiza (bronce), Rusia, República Checa, Italia, Ucrania y Japón. </p>
        <p><a href="http://fie.org/es/competitions/2018/98/results/rank" target="_blank">Se pueden encontrar los resultados completos de la competición individual aquí</a></p>
        <p><a href="http://fie.org/es/competitions/2018/454/results/rank" target="_blank">Y los resultados de la pruebas por equipos aquí </a></p>
      `
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Katowice",
      "index": 24,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg25.png",
      "zoom": null,
      "content": `
        <img id="25-arrow" class="pointer halfScaleBR" style="bottom:178px; right:0px;" onclick="Publish.nextPage();" src="/104/es/static/_content/10-next.png">
        <img id="25-title" class="halfScale" src="/104/es/static/_content/25-title.png" alt="" style="top: 616px; left: -25px;">
        <img id="25-sub" class="halfScale" src="/104/es/static/_content/25-sub.png" alt="" style="top: 87px; left: 713px;">
        <img id="25-line" class="halfScale" src="/104/es/static/_content/9-line.png" alt="" style="top: 156px; left: 710px;">
      `,
      "script": `
        function onPageEnter() {
          page25Anim = new TimelineMax()
          page25Anim
            .fromTo(idOf("25-title"), 0.5,{x:-100, opacity:0, }, {x:0, opacity:1},0.5)
            .fromTo(idOf("25-line"), 0.3,{opacity:0, y:50}, {y:0,opacity:1},"-=0.2")
            .fromTo(idOf("25-sub"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1},"+=0.1")
            .fromTo(idOf("25-arrow"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
        }

        function onPageLeave() {
          page25Anim.stop()
        }
      `,
      "searchText": `
      Deriglazova de Rusia y el equipo de Rusia obtienen el oro en la Copa del Mundo de Florete femenino en Katowice 

      KATOWICE, Polonia  
12 al 14 de Enero de 2018 
FLORETE FEMENINO
        `,
      "mobileHtml": `<h2>Deriglazova de Rusia y el equipo de Rusia obtienen el oro en la Copa del Mundo de Florete femenino en Katowice </h2>

      <p><b>KATOWICE, Polonia<br>
      12 al 14 de Enero de 2018 <br>
      FLORETE FEMENINO</b></p> `
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Katowice",
      "index": 25,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg26.png",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img  class="halfScale pulse animatedpulse" src="/104/es/static/_content/10-tw.png" alt="" style="top:423px; left: 56px;">
        </a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScale pulse animatedpulse" src="/104/es/static/_content/10-fb.png" alt="" style="top: 423px; left: 124px;">
        </a>
        <a href="http://fie.org/es/competitions/2018/127/results/rank" target="_blank">
        <img class="halfScale pulse animatedpulse" src="/104/es/static/_content/trophy1.png" alt="" style="top: 624px; left: 61px;">
        </a>
        <a href="http://fie.org/es/competitions/2018/824/results/rank" target="_blank">
        <img class="halfScale pulse animatedpulse" src="/104/es/static/_content/trophy1.png" alt="" style="top: 830px; left: 61px;">
        </a>
        <img id="26-arrow" class="pointer halfScaleBR" style="bottom:178px; right:21px;" onclick="Publish.nextPage();" src="/104/es/static/_content/10-next.png">
        <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
          <a href="http://www.fie.org/es" target="_blank"></a></div>
      `,
      "script": `
        function onPageEnter() {
          page26Anim = new TimelineMax()
          page26Anim
            .fromTo(idOf("26-arrow"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
        }

        function onPageLeave() {
          page26Anim.stop()
          removeContentLinks()
        }
      `,
      "searchText": `
      La medallista de oro olímpica rusa y la dos veces campeona del mundo en florete femenino, Inna Deriglazova, una vez más ganó el oro en la Copa del Mundo de Florete femenino Artus Court PKO BP celebrada este fin de semana en Katowice, Polonia.

El equipo de florete femenino de Rusia también ganó el oro en la prueba, que se realizó en el estadio Spodek de la ciudad. Compitieron casi 200 de las mejores mujeres floretistas del mundo, así como 21 equipos de diferentes países.

Deriglazova ganó la final contra Lee Kiefer de EEUU, 15-4. En la semifinal, Deriglazova venció a la italiana Camilla Mancini, 15-6, mientras Kiefer superó a la alemana Anne Sauer, 15-7, en la misma vuelta.

En la prueba de florete femenino por equipos, Rusia ganó el oro superando a Italia, 45-39, en el partido final. Italia venció a Francia en la semifinal, 45-35, mientras que Rusia derrotó a Alemania, 42-31. Por la medalla de bronce, Francia ganó a Alemania con una puntuación de 45-22. 

Las ocho primeras posiciones de la clasificación general de florete femenino en la categoría individual de la Copa del Mundo las ocupan Inna Deriglazova (RUS, oro), Lee Kiefer (EEUU, plata), Camilla Mancini (ITA, bronce), Anne Sauer (GER, bronce), Eleanor Harvey (CAN), Seo In Hong (COR), Leyla Pirieva (RUS) y Sera Azuma (JPN). 

Las ocho primeras posiciones de la clasificación general de florete femenino por equipos las ocupan: primero Rusia (oro), seguida de Italia (plata), Francia (bronce), Alemania, EEUU, Polonia, China y Hungría.

Se pueden encontrar los resultados completos de la competición individual aquí

Y los resultados de la pruebas por equipos aquí
      
      `,
  "mobileHtml": `

      <img id="katowiceimg" src="/104/es/static/_mobile/pg25-katowice.jpg">

      <p>La medallista de oro olímpica rusa y la dos veces campeona del mundo en florete femenino, Inna Deriglazova, una vez más ganó el oro en la Copa del Mundo de Florete femenino Artus Court PKO BP celebrada este fin de semana en Katowice, Polonia.</p>
      <p>El equipo de florete femenino de Rusia también ganó el oro en la prueba, que se realizó en el estadio Spodek de la ciudad. Compitieron casi 200 de las mejores mujeres floretistas del mundo, así como 21 equipos de diferentes países.</p>
      <p>Deriglazova ganó la final contra Lee Kiefer de EEUU, 15-4. En la semifinal, Deriglazova venció a la italiana Camilla Mancini, 15-6, mientras Kiefer superó a la alemana Anne Sauer, 15-7, en la misma vuelta.</p>

      <p>En la prueba de florete femenino por equipos, Rusia ganó el oro superando a Italia, 45-39, en el partido final. Italia venció a Francia en la semifinal, 45-35, mientras que Rusia derrotó a Alemania, 42-31. Por la medalla de bronce, Francia ganó a Alemania con una puntuación de 45-22. </p>

      <p>Las ocho primeras posiciones de la clasificación general de florete femenino por equipos las ocupan: primero Rusia (oro), seguida de Italia (plata), Francia (bronce), Alemania, EEUU, Polonia, China y Hungría. </p>

      <p><a href="http://fie.org/es/competitions/2018/127/results/rank" target="_blank">Se pueden encontrar los resultados completos de la competición individual aquí</a></p>
      <p><a href="http://fie.org/es/competitions/2018/824/results/rank" target="_blank">Y los resultados de la pruebas por equipos aquí</a></p>`
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 26,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg27.png",
      "zoom": null,
      "content": `
        <div class="contentLink" style="bottom:573px;right:43px;width:710px; height:57px;">
         <a href="http://www.absolutefencinggear.com" target="_blank"></a>
       </div>
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "",
      "mobileHtml": `
      <a href="http://www.absolutefencinggear.com" target="_blank">
        <img id="ad15img" src="/104/es/static/_mobile/pg27-absolute.png"> 
      </a>
      `
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 27,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg28.jpg",
      "zoom": null,
      "content": `
      <svg class="abs pulse animatedpulse" style="bottom:460px;left:78px;" width="69.4px" height="67.4px" viewBox="0 0 69.4 67.4">
        <path fill="#ffffff" d="M52,34.4L24,50.6V18.1L52,34.4z M67.4,33.7C67.4,15.1,52.3,0,33.7,0C15.1,0,0,15.1,0,33.7 c0,18.6,15.1,33.7,33.7,33.7C52.3,67.4,67.4,52.3,67.4,33.7"/>
      </svg>
      <div class="abs pointer" onclick="Publish.openVideo('/104/es/static/_content/pg28-vid.mp4');" style="bottom:452px;left:78px;width:82px;height:84px;"></div>
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "",
      "mobileHtml":`
      <a href="https://www.allstar.de/home-en.html" target="_blank">
        <img id="ad28img" src="/104/es/static/_mobile/pg28-allstar.png">
      </a>
      <h4><a onclick="Publish.openVideo('/104/es/static/_content/pg28-vid.mp4');" target="_blank">Haga clic aquí para reproducir el vídeo</a></h4>`
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Padua",
      "index": 28,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg29.png",
      "zoom": null,
      "content": `
        <img id="210-next" class="pointer halfScaleBR" style="bottom:178px; right:0px;" onclick="Publish.nextPage();" src="/104/es/static/_content/10-next.png">
        <img id="29-title" class="halfScale" src="/104/es/static/_content/29-title.png" alt="" style="top: 88px; left: 556px;">
        <img id="29-sub" class="halfScale" src="/104/es/static/_content/29-sub.png" alt="" style="top: 728px; left: 604px;">
        <img id="29-line" class="halfScale" src="/104/es/static/_content/9-line.png" alt="" style="top: 728px; left: 544px;">
      `,
      "script": `
        function onPageEnter() {
          page29Anim = new TimelineMax()
          page29Anim
            .fromTo(idOf("29-title"), 0.5,{x:-100, opacity:0, }, {x:0, opacity:1},0.5)
            .fromTo(idOf("29-line"), 0.3,{opacity:0, y:50}, {y:0,opacity:1},"-=0.2")
            .fromTo(idOf("29-sub"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1},"+=0.1")
            .fromTo(idOf("210-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
        }

        function onPageLeave() {
          page29Anim.stop()
        }
      `,
      "searchText": `DERSHWITZ DE EEUU Y EL EQUIPO COREANO SE HACEN CON EL ORO

      PADUA, ITALIA
      2 AL 4 DE FEBRERO DE 2018
      SABLE MASCULINO
        `,
      "mobileHtml": `
        <h2>DERSHWITZ DE EEUU Y EL EQUIPO COREANO SE HACEN CON EL ORO </h2>

        <p><b>PADUA, ITALIA <br>
        2 AL 4 DE FEBRERO DE 2018 <br>
        SABLE MASCULINO</b></p>

      `
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Padua",
      "index": 29,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg30.png",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img  class="halfScale pulse animatedpulse" src="/104/es/static/_content/10-tw.png" alt="" style="top:423px; left: 56px;">
        </a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScale pulse animatedpulse" src="/104/es/static/_content/10-fb.png" alt="" style="top: 423px; left: 124px;">
        </a>
        <a href="http://fie.org/es/competitions/2018/156/results/rank" target="_blank">
        <img class="halfScale pulse animatedpulse" src="/104/es/static/_content/trophy1.png" alt="" style="top: 663px; left: 61px;">
        </a>
        <a href="http://fie.org/es/competitions/2018/758/results/rank" target="_blank">
        <img class="halfScale pulse animatedpulse" src="/104/es/static/_content/trophy1.png" alt="" style="top: 866px; left: 61px;">
        </a>
        <img id="30-arrow" class="pointer halfScaleBR" style="bottom:178px; right:21px;" onclick="Publish.nextPage();" src="/104/es/static/_content/10-next.png">
        <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
          <a href="http://www.fie.org/es" target="_blank"></a></div>
      `,
      "script": `
        function onPageEnter() {
          page30Anim = new TimelineMax()
          page30Anim
            .fromTo(idOf("30-arrow"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
        }

        function onPageLeave() {
          page30Anim.stop()
          removeContentLinks()
        }
      `,
      "searchText": `El esgrimista estadounidense Eli Dershwitz ganó el oro en Padua, Italia, en la Copa del Mundo Masculina de Sable Trophée Luxardo. 

      El equipo coreano masculino de sable también logró alzarse con el oro en la prueba, que tuvo lugar en el histórico Kioene Arena de la ciudad. Más de 200 esgrimistas participaron en la competición, junto con más de 20 equipos internacionales.
      
      Dershwitz derrotó al dos veces campeón olímpico húngaro Aron Szilagyi en el partido final, 15-12, ganando así el Trophée Luxardo. El estadounidense derrotó al italiano Luca Curatoli en la semifinal, 15-13, mientras que Szilagyi eliminó a su compañero de equipo y campeón del mundo, Andras Szatmari, en la misma ronda, 15-11. Dershwitz también venció al mejor espadachín coreano de sable, Bongil Gu en los cuartos de final, 15-4.
      
      En la prueba de sable por equipos, Corea prevaleció contra el equipo local Italiano, 45-33. En las semifinales, Corea logró la misma puntuación frente a Estados Unidos, 45-33, mientras que Italia superó a Hungría, 45-40. En la batalla por la medalla de bronce entre Hungría y Estados Unidos, fue Hungría la que se llevó todos los honores 45-34.
      
      La clasificación de los ocho mejores sables individuales masculinas de la Copa del Mundo de Padua, posiciona a Eli Dershwitz (EEUU, oro), Aron Szilagyi (HUN, plata), Luca Curatoli (ITA, bronce), Andras Szatmari (HUN, bronce), Bongil Gu (COR), Sanguk Oh (COR), Andriy Yagodka (UKR), and Veniamin Reshetnikov (RUS).
      
      La clasificación de los ocho mejores equipos masculinos de sable, posiciona en primer lugar a Corea (oro), seguido de Italia (plata), Hungría (bronce), EEUU, Rusia, Irán, Alemania y Rumanía.
      
      Se pueden encontrar los resultados completos de la competición
      
      Se pueden encontrar los resultados completos de la competición individual aquí
      
      Y los resultados de la pruebas por equipos aquí`,

    "mobileHtml": `

      <img id="paduaimg" src="/104/es/static/_mobile/pg29-padua.jpg">

      <p>El esgrimista estadounidense Eli Dershwitz ganó el oro en Padua, Italia, en la Copa del Mundo Masculina de Sable Trophée Luxardo. </p>

      <p>El equipo coreano masculino de sable también logró alzarse con el oro en la prueba, que tuvo lugar en el histórico Kioene Arena de la ciudad. Más de 200 esgrimistas participaron en la competición, junto con más de 20 equipos internacionales.</p>

      <p>Dershwitz derrotó al dos veces campeón olímpico húngaro Aron Szilagyi en el partido final, 15-12, ganando así el Trophée Luxardo. El estadounidense derrotó al italiano Luca Curatoli en la semifinal, 15-13, mientras que Szilagyi eliminó a su compañero de equipo y campeón del mundo, Andras Szatmari, en la misma ronda, 15-11. Dershwitz también venció al mejor espadachín coreano de sable, Bongil Gu en los cuartos de final, 15-4.</p>

      <p>En la prueba de sable por equipos, Corea prevaleció contra el equipo local Italiano, 45-33. En las semifinales, Corea logró la misma puntuación frente a Estados Unidos, 45-33, mientras que Italia superó a Hungría, 45-40. En la batalla por la medalla de bronce entre Hungría y Estados Unidos, fue Hungría la que se llevó todos los honores 45-34.</p>

      <p>La clasificación de los ocho mejores sables individuales masculinas de la Copa del Mundo de Padua, posiciona a Eli Dershwitz (EEUU, oro), Aron Szilagyi (HUN, plata), Luca Curatoli (ITA, bronce), Andras Szatmari (HUN, bronce), Bongil Gu (COR), Sanguk Oh (COR), Andriy Yagodka (UKR), and Veniamin Reshetnikov (RUS).</p>

      <p>La clasificación de los ocho mejores equipos masculinos de sable, posiciona en primer lugar a Corea (oro), seguido de Italia (plata), Hungría (bronce), EEUU, Rusia, Irán, Alemania y Rumanía.</p>

      <p>Se pueden encontrar los resultados completos de la competición</p>

      <p><a href="http://fie.org/es/competitions/2018/156/results/rank" target="_blank">Se pueden encontrar los resultados completos de la competición individual aquí</a></p>
      <p><a href="http://fie.org/es/competitions/2018/758/results/rank" target="_blank">Y los resultados de la pruebas por equipos aquí</a></p>
    `
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "París",
      "index": 30,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg31.png",
      "zoom": null,
      "content": `
        <img id="31-arrow" class="pointer halfScaleBR" style="bottom:178px; right:0px;" onclick="Publish.nextPage();" src="/104/es/static/_content/10-next.png">
        <img id="31-title" class="halfScale" src="/104/es/static/_content/31-title.png" alt="" style="top: 39px; left: 42px;">
        <img id="31-sub" class="halfScale" src="/104/es/static/_content/31-sub.png" alt="" style="top: 412px; left: 289px;">
        <img id="31-line" class="halfScale" src="/104/es/static/_content/9-line.png" alt="" style="top: 485px; left: 286px;">
      `,
      "script": `
        function onPageEnter() {
          page31Anim = new TimelineMax()
          page31Anim
            .fromTo(idOf("31-title"), 0.5,{x:-100, opacity:0, }, {x:0, opacity:1},0.5)
            .fromTo(idOf("31-line"), 0.3,{opacity:0, y:50}, {y:0,opacity:1},"-=0.2")
            .fromTo(idOf("31-sub"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1},"+=0.1")
            .fromTo(idOf("31-arrow"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
        }

        function onPageLeave() {
          page31Anim.stop()
        }
      `,
      "searchText": `EL ITALIANO FOCONI Y EL EQUIPO DE EEUU GANAN EL ORO 

      PARÍS, FRANCIA  
19 AL 21 DE ENERO DE 2018
FLORETE MASCULINO
`,
      "mobileHtml": `
      <h2>EL ITALIANO FOCONI Y EL EQUIPO DE EEUU GANAN EL ORO </h2>

      <p><b>PARÍS, FRANCIA <br>
      19 AL 21 DE ENERO DE 2018 <br>
      FLORETE MASCULINO</b></p>
      
      `
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "París",
      "index": 31,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg32.png",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img  class="halfScale pulse animatedpulse" src="/104/es/static/_content/10-tw.png" alt="" style="top:423px; left: 56px;">
        </a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScale pulse animatedpulse" src="/104/es/static/_content/10-fb.png" alt="" style="top: 423px; left: 124px;">
        </a>
        <a href="http://fie.org/es/competitions/2018/142/results/rank" target="_blank">
        <img class="halfScale pulse animatedpulse" src="/104/es/static/_content/trophy1.png" alt="" style="top: 659px; left: 61px;">
        </a>
        <a href="http://fie.org/es/competitions/2018/208/results/rank" target="_blank">
        <img class="halfScale pulse animatedpulse" src="/104/es/static/_content/trophy1.png" alt="" style="top: 860px; left: 61px;">
        </a>
        <img id="32-arrow" class="pointer halfScaleBR" style="bottom:178px; right:21px;" onclick="Publish.nextPage();" src="/104/es/static/_content/10-next.png">
        <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
          <a href="http://www.fie.org/es" target="_blank"></a></div>
      `,
      "script": `
        function onPageEnter() {
          page32Anim = new TimelineMax()
          page32Anim
            .fromTo(idOf("32-arrow"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
        }

        function onPageLeave() {
          page32Anim.stop()
          removeContentLinks()
        }
      `,
      "searchText": `
      El italiano Alessio Foconi consiguió el oro en florete individual masculino en el desafío internacional de la Copa del Mundo de París. 

Los Estados Unidos consiguieron una medalla de oro en el match. La prueba, que se celebró en el Estadio Pierre de Coubertin. atrajo a más de 250 competidores internacionales de gran experiencia, así como más de 30 equipos de todo el mundo.

Fue un final muy positivo para Italia, que ganó tres de las cuatro medallas individuales y una medalla de plata en la prueba por equipos. Foconi batió a su compañero de equipo y medallista de oro olímpico Daniele Garozzo, por 15-10, en el match final de la prueba individual. En las semifinales, Foconi también derrotó a su compañero de equipo Giorgio Avola, por 15-10. Garozzo venció al francés Julien Mertine, por 15-13, en la misma ronda.

En la prueba de florete por equipos, el equipo masculino de EEUU ganó la final frente a Italia, por 45-36. EEUU también venció a Corea en las semifinales, por 45-25, e Italia superó por poco a Francia, por 45-42. La medalla de bronce fue para Francia, que derrotó a Corea, por 45-19.

La clasificación general de los ocho mejores en florete masculino individual del desafío internacional de la Copa del Mundo de París coloca a Alessio Foconi (ITA, oro), Daniele Garozzo (ITA, plata), Giorgio Avola (ITA, bronce), Julien Mertine (FRA, bronze), Timur Safin (RUS), Richard Kruse (GBR), Race Imboden (USA) y Taegyu Ha (KOR).

La clasificación de los ocho mejores equipos coloca a EEUU (oro) el primero, seguido por Italia (plata), Francia (bronce), Corea, Rusia, Japón, Ucrania y Polonia.

Se pueden encontrar los resultados completos de la competición individual aquí

Y los resultados de la pruebas por equipos aquí`,
    "mobileHtml": `

    <img id="parisimg" src="/104/es/static/_mobile/pg31-paris.jpg">

    <p>El italiano Alessio Foconi consiguió el oro en florete individual masculino en el desafío internacional de la Copa del Mundo de París. </p>

    <p>Los Estados Unidos consiguieron una medalla de oro en el match. La prueba, que se celebró en el Estadio Pierre de Coubertin. atrajo a más de 250 competidores internacionales de gran experiencia, así como más de 30 equipos de todo el mundo.</p>

    <p>Fue un final muy positivo para Italia, que ganó tres de las cuatro medallas individuales y una medalla de plata en la prueba por equipos. Foconi batió a su compañero de equipo y medallista de oro olímpico Daniele Garozzo, por 15-10, en el match final de la prueba individual. En las semifinales, Foconi también derrotó a su compañero de equipo Giorgio Avola, por 15-10. Garozzo venció al francés Julien Mertine, por 15-13, en la misma ronda.</p>

    <p>En la prueba de florete por equipos, el equipo masculino de EEUU ganó la final frente a Italia, por 45-36. EEUU también venció a Corea en las semifinales, por 45-25, e Italia superó por poco a Francia, por 45-42. La medalla de bronce fue para Francia, que derrotó a Corea, por 45-19.</p>

    <p>La clasificación general de los ocho mejores en florete masculino individual del desafío internacional de la Copa del Mundo de París coloca a Alessio Foconi (ITA, oro), Daniele Garozzo (ITA, plata), Giorgio Avola (ITA, bronce), Julien Mertine (FRA, bronze), Timur Safin (RUS), Richard Kruse (GBR), Race Imboden (USA) y Taegyu Ha (KOR). </p>

    <p>La clasificación de los ocho mejores equipos coloca a EEUU (oro) el primero, seguido por Italia (plata), Francia (bronce), Corea, Rusia, Japón, Ucrania y Polonia. </p>

    <p><a href="http://fie.org/es/competitions/2018/142/results/rank" target="_blank">Se pueden encontrar los resultados completos de la competición individual aquí</a></p>
    <p><a href="http://fie.org/es/competitions/2018/208/results/rank" target="_blank">Y los resultados de la pruebas por equipos aquí</a></p>
    `
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 32,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg33.png",
      "zoom": null,
      "content": `
        <div class="contentLink" style="bottom:42px;left:203px;width:282px; height:40px;">
          <a href="http://www.pbtfencing.com" target="_blank"></a>
        </div>
        <div class="contentLink" style="bottom:42px;left:614px;width:302px; height:40px;">
          <a href="mailto:sales@pbtfencing.com" target="_blank"></a>
        </div>
        <div class="contentLink" style="bottom:42px;left:1022px;width:322px; height:40px;">
          <a href="http://www.fb.com/pbtfencing" target="_blank"></a>
        </div>
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "",
      "mobileHtml": `
      <img id="ad33img" src="/104/es/static/_mobile/pg33-pbt.jpg">
      `
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 33,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg34.png",
      "zoom": null,
      "content": `

      <div class="contentLink" style="bottom:255px;right:164px;width:308px; height:25px;">
        <a href="http://www.facebook.com/fie.org" target="_blank"></a>
      </div>
      <div class="contentLink" style="bottom:231px;right:282px;width:190px; height:25px;">
        <a href="http://www.twitter.com/fie_fencing" target="_blank"></a>
      </div>
      <div class="contentLink" style="bottom:208px;right:282px;width:190px; height:25px;">
        <a href="http://www.instagram.com/fencing_fie" target="_blank"></a>
      </div>
      <div class="contentLink" style="bottom:184px;right:110px;width:360px; height:25px;">
        <a href="http://plus.google.com/+fievideo" target="_blank"></a>
      </div>
      <div class="contentLink" style="bottom:158px;right:110px;width:360px; height:25px;">
        <a href="http://www.youtube.com/user/fievideo" target="_blank"></a>
      </div>
      <div class="contentLink" style="bottom:79px;right:190px;width:280px; height:25px;">
        <a href="http://www.fie.org/media" target="_blank"></a>
      </div>
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "",
      "mobileHtml": `
      <a href="http://www.fie.org/media" target="_blank">
        <img id="ad34img" src="/104/es/static/_mobile/pg34-grandprix.jpg">
      </a>
      `
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Richmond",
      "index": 34,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg35.png",
      "zoom": null,
      "content": `
        <img id="35-arrow" class="pointer halfScaleBR" style="bottom:178px; right:0px;" onclick="Publish.nextPage();" src="/104/es/static/_content/10-next.png">
        <img id="35-title" class="halfScale" src="/104/es/static/_content/35-title.png" alt="" style="top: 17px; left: 17px;">
        <img id="35-sub" class="halfScale" src="/104/es/static/_content/35-sub.png" alt="" style="top: 873px; left: 90px;">
        <img id="35-line" class="halfScale" src="/104/es/static/_content/9-line.png" alt="" style="top: 943px; left: 87px;">
      `,
      "script": `
        function onPageEnter() {
          page35Anim = new TimelineMax()
          page35Anim
            .fromTo(idOf("35-title"), 0.5,{x:-100, opacity:0, }, {x:0, opacity:1},0.5)
            .fromTo(idOf("35-line"), 0.3,{opacity:0, y:50}, {y:0,opacity:1},"-=0.2")
            .fromTo(idOf("35-sub"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1},"+=0.1")
            .fromTo(idOf("35-arrow"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
        }

        function onPageLeave() {
          page35Anim.stop()
        }
      `,
      "searchText": `
      NIKISHIN DE UCRANIA Y EL EQUIPO DE FRANCIA LOGRAN LA VICTORIA

      RICHMOND, CANADÁ   
16 AL 18 DE FEBRERO DE 2018
ESPADA MASCULINA
        `,
      "mobileHtml": `
        <h2>NIKISHIN DE UCRANIA Y EL EQUIPO DE FRANCIA LOGRAN LA VICTORIA</h2>
        <p><b>
        RICHMOND, CANADÁ <br>
        16 AL 18 DE FEBRERO DE 2018<br>
        ESPADA MASCULINA</b></p>
      `
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Richmond",
      "index": 35,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg36.png",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img  class="halfScale pulse animatedpulse" src="/104/es/static/_content/10-tw.png" alt="" style="top:423px; left: 56px;">
        </a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScale pulse animatedpulse" src="/104/es/static/_content/10-fb.png" alt="" style="top: 423px; left: 124px;">
        </a>
        <a href="http://fie.org/es/competitions/2018/104/results/rank" target="_blank">
        <img class="halfScale pulse animatedpulse" src="/104/es/static/_content/trophy1.png" alt="" style="top: 566px; left: 61px;">
        </a>
        <a href="http://fie.org/es/competitions/2018/489/results/rank" target="_blank">
        <img class="halfScale pulse animatedpulse" src="/104/es/static/_content/trophy1.png" alt="" style="top: 770px; left: 61px;">
        </a>
        <img id="36-arrow" class="pointer halfScaleBR" style="bottom:178px; right:21px;" onclick="Publish.nextPage();" src="/104/es/static/_content/10-next.png">
        <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
          <a href="http://www.fie.org/es" target="_blank"></a></div>
      `,
      "script": `
        function onPageEnter() {
          page36Anim = new TimelineMax()
          page36Anim
            .fromTo(idOf("36-arrow"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
            
        }

        function onPageLeave() {
          page36Anim.stop()
        }
      `,
      "searchText": `
      El esgrimista ucraniano Bogdan Nikishin se llevó el oro en Richmond, Canadá, en la Copa del Mundo Masculina de Espada Peter Bakonyi. 

El esgrimista ucraniano Bogdan Nikishin se llevó el oro en Richmond, Canadá, en la Copa del Mundo Masculina de Espada Peter Bakonyi. El equipo francés de espada masculina ganó la prueba por equipos, ambas pruebas tuvieron lugar en el Richmond Olympic Oval. La Copa del Mundo atrajo a más de 185 espadachines internacionales, así como a 24 equipos internacionales.

Nikishin, de 37 años, ocupa el segundo lugar en la clasificación mundial, tiene dos Grand Prix individuales y ahora cuenta con cuatro victorias en la copa del mundo a su nombre. Derrotó al francés Daniel Jerent en la final, 15-13, y antes de eso eliminó al compañero de Jerent, Yannick Borel, en la semifinal, 15-11. Jerent venció al esgrimista checo Pavel Pitra, 15-9, en la misma ronda.

En la prueba masculina prueba por equipos, Francia superó a Italia en la ronda final 45-41. Italia venció a Corea en la semifinal, 45-33, mientras que Francia derrotó a Hungría, 45-32. Tras derrotas a Hungría, Corea se llevó la medalla de broncea casa, 45-32.

La clasificación de las ocho mejores espadas individuales masculinas de la Copa del Mundo Masculina Peter Bakonyi, posiciona a Bogdan Nikishin (UKR, oro), Daniel Jerent (FRA, plata), Yannick Borel (FRA, bronce), Pavel Pitra(CZE, bronce), Jakub Jurka (CZE), Gabriele Cimini (ITA), Ronan Gustin (FRA), and Yulen Pereira (ESP).

La clasificación de los ocho mejores equipos masculinos de espada, posiciona en primer lugar a Francia (oro), seguido de Italia (plata), Corea (bronce), Hungría, Ucrania, Alemania, EEUUy Rusia.

Se pueden encontrar los resultados completos de la competición individual aquí

Y los resultados de la pruebas por equipos aquí`,
    "mobileHtml": `


      <img id="richmondimg" src="/104/es/static/_mobile/pg35-richmond.jpg">

      <p>El esgrimista ucraniano Bogdan Nikishin se llevó el oro en Richmond, Canadá, en la Copa del Mundo Masculina de Espada Peter Bakonyi. </p>
 
      <p>El esgrimista ucraniano Bogdan Nikishin se llevó el oro en Richmond, Canadá, en la Copa del Mundo Masculina de Espada Peter Bakonyi. El equipo francés de espada masculina ganó la prueba por equipos, ambas pruebas tuvieron lugar en el Richmond Olympic Oval. La Copa del Mundo atrajo a más de 185 espadachines internacionales, así como a 24 equipos internacionales.</p>

      <p>Nikishin, de 37 años, ocupa el segundo lugar en la clasificación mundial, tiene dos Grand Prix individuales y ahora cuenta con cuatro victorias en la copa del mundo a su nombre. Derrotó al francés Daniel Jerent en la final, 15-13, y antes de eso eliminó al compañero de Jerent, Yannick Borel, en la semifinal, 15-11. Jerent venció al esgrimista checo Pavel Pitra, 15-9, en la misma ronda.</p>

      <p>En la prueba masculina prueba por equipos, Francia superó a Italia en la ronda final 45-41. Italia venció a Corea en la semifinal, 45-33, mientras que Francia derrotó a Hungría, 45-32. Tras derrotas a Hungría, Corea se llevó la medalla de broncea casa, 45-32.</p>

      <p>La clasificación de las ocho mejores espadas individuales masculinas de la Copa del Mundo Masculina Peter Bakonyi, posiciona a Bogdan Nikishin (UKR, oro), Daniel Jerent (FRA, plata), Yannick Borel (FRA, bronce), Pavel Pitra(CZE, bronce), Jakub Jurka (CZE), Gabriele Cimini (ITA), Ronan Gustin (FRA), and Yulen Pereira (ESP).</p>

      <p>La clasificación de los ocho mejores equipos masculinos de espada, posiciona en primer lugar a Francia (oro), seguido de Italia (plata), Corea (bronce), Hungría, Ucrania, Alemania, EEUUy Rusia.</p>
      <p><a href="http://fie.org/es/competitions/2018/104/results/rank" target="_blank">Se pueden encontrar los resultados completos de la competición individual aquí</a></p>
      <p><a href="http://fie.org/es/competitions/2018/489/results/rank" target="_blank">Y los resultados de la pruebas por equipos aquí</a></p>
    `
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Varsovia",
      "index": 36,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg37.png",
      "zoom": null,
      "content": `
        <img id="37-arrow" class="pointer halfScaleBR" style="bottom:178px; right:0px;" onclick="Publish.nextPage();" src="/104/es/static/_content/10-next.png">
        <img id="37-title" class="halfScale" src="/104/es/static/_content/37-title.png" alt="" style="top: 81px; left: 16px;">
        <img id="37-sub" class="halfScale" src="/104/es/static/_content/37-sub.png" alt="" style="top: 367px; left: 85px;">
        <img id="37-line" class="halfScale" src="/104/es/static/_content/9-line.png" alt="" style="top: 433px; left: 84px;">
      `,
      "script": `
        function onPageEnter() {
          page37Anim = new TimelineMax()
          page37Anim
            .fromTo(idOf("37-title"), 0.5,{x:-100, opacity:0, }, {x:0, opacity:1},0.5)
            .fromTo(idOf("37-line"), 0.3,{opacity:0, y:50}, {y:0,opacity:1},"-=0.2")
            .fromTo(idOf("37-sub"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1},"+=0.1")
            .fromTo(idOf("37-arrow"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
        }

        function onPageLeave() {
          page37Anim.stop()
        }
      `,
      "searchText": `GU DE COREA Y EL EQUIPO DE COREA SE LLEVAN LAS MEDALLAS DE ORO

      VARSOVIA, POLONIA 
23 AL 25 DE FEBRERO DE 2018
SABLE MASCULINO
        `,
      "mobileHtml": `
        <h2>GU DE COREA Y EL EQUIPO DE COREA SE LLEVAN LAS MEDALLAS DE ORO</h2>

        <p><b>VARSOVIA, POLONIA<br>
        23 AL 25 DE FEBRERO DE 2018 <br>
        SABLE MASCULINO</b></p>
      `
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Varsovia",
      "index": 37,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg38.png",
      "zoom": null,
      "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img  class="halfScale pulse animatedpulse" src="/104/es/static/_content/10-tw.png" alt="" style="top:423px; left: 56px;">
        </a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScale pulse animatedpulse" src="/104/es/static/_content/10-fb.png" alt="" style="top: 423px; left: 124px;">
        </a>
        <a href="http://fie.org/es/competitions/2018/160/results/rank" target="_blank">
        <img class="halfScale pulse animatedpulse" src="/104/es/static/_content/trophy1.png" alt="" style="top: 626px; left: 61px;">
        </a>
        <a href="http://fie.org/es/competitions/2018/827/results/rank" target="_blank">
        <img class="halfScale pulse animatedpulse" src="/104/es/static/_content/trophy1.png" alt="" style="top: 830px; left: 61px;">
        </a>
        <img id="38-arrow" class="pointer halfScaleBR" style="bottom:178px; right:21px;" onclick="Publish.nextPage();" src="/104/es/static/_content/10-next.png">
        <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
          <a href="http://www.fie.org/es" target="_blank"></a></div>
      `,
      "script": `
        function onPageEnter() {
          page38Anim = new TimelineMax()
          page38Anim
            .fromTo(idOf("38-arrow"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
        }

        function onPageLeave() {
          page38Anim.stop()
          removeContentLinks()
        }
      `,
      "searchText": `Los esgrimistas de sable masculino coreanos dominaron la Copa del Mundo masculina de sable en Varsovia ganando ambos eventos individuales y por equipos. 

      El sexagésimo tercer «Sable de Wolodyjowski» atrajo a más de 200 atletas masculinos internacionales y 24 equipos. Para el número uno del mundo Bongil Gu, ésta fue su séptima medalla de oro en Copa del Mundo y la tercera vez en ganar este evento en Varsovia.
      
      El coreano le ganó al alemán Matyas Szabo en el combate final, ganando 15-10; para Szabo llevarse la medalla de plata fue el mejor resultado individual de su carrera. El alemán le ganó a su compañero de equipo, Benedikt Wagner en la semifinal, 15-11, mientras que Gu le ganó al iraní Ali Pakdaman, ganado con un marcador de 15-13. En un combate muy reñido, Szabo también venció al dos veces medallista de oro olímpico Aron Szilagyi (HUN) en la ronda de 16, 15-14.
      
      En el evento de equipos masculinos de sable, Irán y Corea llegaron a la pista de las finales, Corea ganó el combate con un marcador de  45-31. Irán había ganado a Hungría en la semifinal, 45-37, mientras que Corea derrotó a Rusia, 45-24. La medalla de bronce fue para Hungría en una reñida tercera posición, 45-43.
      
      El ranking de los mejores ocho en fase de individuales masculinos del Sable de Wolodyjowski en la Copa del Mundo de  Varsovia incluyen a Bongil Gu (KOR, oro), Matyas Szabo (GER, plata), Ali Pakdaman (IRI, bronce), Benedikt Wagner (GER, bronce), Andras Szatmari (HUN), Max Hartung (GER), Kamil Ibragimov (RUS), y Bolade Apithy (FRA).
      
      El ranking de los ocho mejores en fase de equipos masculinos de sable coloca a Corea (oro) primero, seguido por Irán (plata), Hungría (bronce), Rusia, Italia, Francia, Georgia y EEUU. 
      
      Se pueden encontrar los resultados completos de la competición individual aquí
      
      Y los resultados de la pruebas por equipos aquí`,

      "mobileHtml": `

      <img id="warsawimg" src="/104/es/static/_mobile/pg37-warsaw.jpg">

      <p>Los esgrimistas de sable masculino coreanos dominaron la Copa del Mundo masculina de sable en Varsovia ganando ambos eventos individuales y por equipos.</p>

      <p>El sexagésimo tercer «Sable de Wolodyjowski» atrajo a más de 200 atletas masculinos internacionales y 24 equipos. Para el número uno del mundo Bongil Gu, ésta fue su séptima medalla de oro en Copa del Mundo y la tercera vez en ganar este evento en Varsovia.</p>

      <p>El coreano le ganó al alemán Matyas Szabo en el combate final, ganando 15-10; para Szabo llevarse la medalla de plata fue el mejor resultado individual de su carrera. El alemán le ganó a su compañero de equipo, Benedikt Wagner en la semifinal, 15-11, mientras que Gu le ganó al iraní Ali Pakdaman, ganado con un marcador de 15-13. En un combate muy reñido, Szabo también venció al dos veces medallista de oro olímpico Aron Szilagyi (HUN) en la ronda de 16, 15-14.</p>

      <p>En el evento de equipos masculinos de sable, Irán y Corea llegaron a la pista de las finales, Corea ganó el combate con un marcador de  45-31. Irán había ganado a Hungría en la semifinal, 45-37, mientras que Corea derrotó a Rusia, 45-24. La medalla de bronce fue para Hungría en una reñida tercera posición, 45-43.</p>

      <p>El ranking de los mejores ocho en fase de individuales masculinos del Sable de Wolodyjowski en la Copa del Mundo de  Varsovia incluyen a Bongil Gu (KOR, oro), Matyas Szabo (GER, plata), Ali Pakdaman (IRI, bronce), Benedikt Wagner (GER, bronce), Andras Szatmari (HUN), Max Hartung (GER), Kamil Ibragimov (RUS), y Bolade Apithy (FRA).</p>

      <p>El ranking de los ocho mejores en fase de equipos masculinos de sable coloca a Corea (oro) primero, seguido por Irán (plata), Hungría (bronce), Rusia, Italia, Francia, Georgia y EEUU.</p>
      
      <p><a href="http://fie.org/es/competitions/2018/160/results/rank" target="_blank">Se pueden encontrar los resultados completos de la competición individual aquí</a></p>
      <p><a href="http://fie.org/es/competitions/2018/827/results/rank" target="_blank">Y los resultados de la pruebas por equipos aquí</a></p>
      `
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 38,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg39.png",
      "zoom": null,
      "content": `
        <div class="contentLink" style="bottom: 335px; right: 370px; width: 160px; height: 40px;">
          <a href="http://www.favero.com" target="_blank"></a>
        </div>
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "",
      "mobileHtml":`
      <a href="http://www.favero.com" target="_blank">
        <img id="ad39img" src="/104/es/static/_mobile/pg39-favero.png">
      </a>
      `
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Mundo Junior y Cadet De Esgrima",
      "index": 39,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg40.png",
      "zoom": null,
      "content": `
      
        <img id="40-arrow" class="pointer halfScaleBR" style="bottom:178px; right:0px;" onclick="Publish.nextPage();" src="/104/es/static/_content/next-purp-small.png">
        <img id="40-title" class="halfScale" src="/104/es/static/_content/40-title.png" alt="" style="top: 72px; left: 17px;">
        <img class="halfScale" src="/104/es/static/_content/9-line.png" alt="" style="top: 664px; left: 275px;">
      `,
      "script": `
        function onPageEnter() {
          page40Anim = new TimelineMax()
          page40Anim
            .fromTo(idOf("40-title"), 0.5,{x:-100, opacity:0, }, {x:0, opacity:1},0.5)
            .fromTo(idOf("40-arrow"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
            
        }

        function onPageLeave() {
          page40Anim.stop()
        }
      `,
      "searchText": `¡Campeonatos del Mundo junior y cadete de esgrima en Verona!

`,
      "mobileHtml": `<h2>¡Campeonatos del Mundo junior y cadete de esgrima en Verona!</h2>`
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Mundo Junior y Cadet De Esgrima",
      "index": 40,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg41.png",
      "zoom": null,
      "content": `
        <img id="41-arrow" class="pointer halfScaleBR" style="bottom:178px; right:0px;" onclick="Publish.nextPage();" src="/104/es/static/_content/next-purp-small.png">
        <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img id="41-tw" class="halfScale pulse animatedpulse" src="/104/es/static/_content/purp-tw.png" alt="" style="top: 422px; left: 54px;"></a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
        <img id="41-fa" class="halfScale pulse animatedpulse" src="/104/es/static/_content/purp-fb.png" alt="" style="top: 422px; left: 124px;"></a>
      `,
      "script": `
        function onPageEnter() {
          page41Anim = new TimelineMax()
          page41Anim
            .fromTo(idOf("41-arrow"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1}, 0.5)

        }

        function onPageLeave() {
          page41Anim.stop()
        }
      `,
      "searchText": `
      Shakespeare escogió Verona como escenario para Romeo y Julieta y es en esta preciosa e histórica ciudad italiana, Patrimonio Mundial por la UNESCO, donde la FIE y la Federación Italiana de Esgrima (FIE) acogerán los Campeonatos del Mundo junior y cadete de esgrima.

Desde la herencia artística y los prósperos programas de arte hasta el antiguo anfiteatro romano hacen de Verona una ciudad única, que este año añadirá a su historia la proclamación de los nuevos campeones del mundo individuales y por equipos de esgrima. En el transcurso de nueve días, más de mil jóvenes competirán con otros esgrimistas de todo el planeta, muchos de ellos participando por primera vez en la escena mundial. 

El Campeonato tendrá lugar en la nueva sede de la sociedad deportiva Cattolica situada en el área industrial de Verona, cerca del parque de atracciones de la ciudad, y se espera la participación de más de 130 países. Tanto la ciudad como la región acogerán numerosas actividades complementarias al Campeonato, en especial para acercar a los jóvenes de la región la oportunidad de vivir, en primera persona, la esgrima mundial. 
      `,
      "mobileHtml": `

      <img id="previewimg" src="/104/es/static/_mobile/pg40-preview.jpg">

      <p>Shakespeare escogió Verona como escenario para Romeo y Julieta y es en esta preciosa e histórica ciudad italiana, Patrimonio Mundial por la UNESCO, donde la FIE y la Federación Italiana de Esgrima (FIE) acogerán los Campeonatos del Mundo junior y cadete de esgrima.</p>

      <p>Desde la herencia artística y los prósperos programas de arte hasta el antiguo anfiteatro romano hacen de Verona una ciudad única, que este año añadirá a su historia la proclamación de los nuevos campeones del mundo individuales y por equipos de esgrima. En el transcurso de nueve días, más de mil jóvenes competirán con otros esgrimistas de todo el planeta, muchos de ellos participando por primera vez en la escena mundial. </p>

      <p>El Campeonato tendrá lugar en la nueva sede de la sociedad deportiva Cattolica situada en el área industrial de Verona, cerca del parque de atracciones de la ciudad, y se espera la participación de más de 130 países. Tanto la ciudad como la región acogerán numerosas actividades complementarias al Campeonato, en especial para acercar a los jóvenes de la región la oportunidad de vivir, en primera persona, la esgrima mundial. </p>
      `
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Mundo Junior y Cadet De Esgrima",
      "index": 41,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg42.png",
      "zoom": null,
      "content": `
      <div class="addContentLink" style="top: 950px; left: 1059px; width: 276px; height: 31px;">
        <a href="http://www.FencingVerona2018.com" target="_blank"></a>
      </div>
      <div class="addContentLink" style="top: 980px; left: 840px; width: 56px; height: 31px;">
        <a href="http://www.FencingVerona2018.com" target="_blank"></a>
      </div>
      <div class="addContentLink" style="top: 923px;left: 1045px;width: 146px;height: 26px;">
        <a href="http://www.fie.org/es" target="_blank"></a>
      </div>
        <img id="42-arrow" class="pointer halfScaleBR" style="bottom:178px; right:21px;" onclick="Publish.nextPage();" src="/104/es/static/_content/next-purp-small.png">
        <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img id="42-tw" class="halfScale pulse animatedpulse" src="/104/es/static/_content/purp-tw.png" alt="" style="top: 422px; left: 54px;"></a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
        <img id="42-fa" class="halfScale pulse animatedpulse" src="/104/es/static/_content/purp-fb.png" alt="" style="top: 422px; left: 124px;"></a>
      <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
          <a href="http://www.fie.org/es" target="_blank"></a></div>
      `,
      "script": `
        function onPageEnter() {
          page42Anim = new TimelineMax()
          page42Anim
            .fromTo(idOf("42-arrow"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
        }

        function onPageLeave() {
          page42Anim.stop()
          removeContentLinks()
        }
      `,
      "searchText": `
      
      El Campeonato contará con seis pruebas individuales para cadetes y para juniors (tres armas, masculina y femenina) y seis pruebas junior por equipos (también con tres armas, masculina y femenina), sumando un total de 18. En ocasiones anteriores, el calendario del Campeonato del Mundo junior y cadete de esgrima se había dividido en tres partes: las pruebas individuales cadete, las pruebas individuales junior y por último, las pruebas por equipos junior. Este año, en cambio, el calendario del programa se dividirá por arma. El primer día tendrá lugar la competición de espada junior, seguida, al día siguiente, de la espada cadete y para finalizar, durante la tercera jornada, la prueba por equipos.  En este formato se utilizará el sable y después, para finalizar el Campeonato, el florete. 

Este nuevo formato ayuda a la organización general de la competición además de facilitar y hacer más práctica la labor de los árbitros y del Directorio Técnico (DT). Asimismo, debido a que algunos de los esgrimistas compiten en dos o tres pruebas (cadete, junior y equipo junior), esta reorganización permite que participen en todas las pruebas sin tener que esperar varios días entre una y otra, lo que ayuda a que tanto los participantes como las federaciones ahorren tiempo y dinero, además de facilitar la organización y coordinación de los campeonatos. 

La ceremonia inaugural tendrá lugar el lunes 2 de abril a las 18h. Podrá encontrar más información en la página web de la FIE 
(www.FIE.org) y en la página oficial de Verona 2018 www.FencingVerona2018.com. 
      `,
      "mobileHtml": `
      <p>El Campeonato contará con seis pruebas individuales para cadetes y para juniors (tres armas, masculina y femenina) y seis pruebas junior por equipos (también con tres armas, masculina y femenina), sumando un total de 18. En ocasiones anteriores, el calendario del Campeonato del Mundo junior y cadete de esgrima se había dividido en tres partes: las pruebas individuales cadete, las pruebas individuales junior y por último, las pruebas por equipos junior. Este año, en cambio, el calendario del programa se dividirá por arma. El primer día tendrá lugar la competición de espada junior, seguida, al día siguiente, de la espada cadete y para finalizar, durante la tercera jornada, la prueba por equipos.  En este formato se utilizará el sable y después, para finalizar el Campeonato, el florete.  </p>

      <p>Este nuevo formato ayuda a la organización general de la competición además de facilitar y hacer más práctica la labor de los árbitros y del Directorio Técnico (DT). Asimismo, debido a que algunos de los esgrimistas compiten en dos o tres pruebas (cadete, junior y equipo junior), esta reorganización permite que participen en todas las pruebas sin tener que esperar varios días entre una y otra, lo que ayuda a que tanto los participantes como las federaciones ahorren tiempo y dinero, además de facilitar la organización y coordinación de los campeonatos. </p>

      <p>La ceremonia inaugural tendrá lugar el lunes 2 de abril a las 18h. Podrá encontrar más información en la página web de la FIE (<a href="http://www.fie.org/es" target="_blank">www.fie.org/es</a>) y en la página oficial de Verona 2018, <a href="http://www.FencingVerona2018.com" target="_blank">www.FencingVerona2018.com</a>.</p>
      `
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Conozca A Los Atletas",
      "index": 42,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg43.png",
      "zoom": null,
      "content": `
        <img id="43-title" class="halfScale" style="top:645px;left:-317px;" src="/104/es/static/_content/43-t1.png">
        <img id="43-title2" class="halfScaleR" style="top:800px;right:-80px;" src="/104/es/static/_content/43-t2.png">
        <img id="43-arrow" class="pointer halfScaleBR" style="bottom:58px; right:0px;" onclick="Publish.nextPage();" src="/104/es/static/_content/43-next.jpg">
      `,
      "script": `
        function onPageEnter() {
          page43Anim = new TimelineMax()
          page43Anim
            .fromTo(idOf("43-title"), 0.5,{x:-800,opacity:0}, {x:0,opacity:1},0.5)
            .fromTo(idOf("43-title2"), 0.5,{x:800,opacity:0}, {x:0,opacity:1},"-=0.3")
            .fromTo(idOf("43-arrow"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
        }

        function onPageLeave() {
          page43Anim.stop()
        }
      `,
      "searchText": `7:1 Davide Di VEROLI`,
      "mobileHtml": `<h2>7:1 Davide Di VEROLI</h2>`
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Conozca A Los Atletas",
      "index": 43,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg44.png",
      "zoom": null,
      "content": `
        <div id="interview" class="abs" style="top:418px;left:731px">
          <img src="/104/es/static/_content/44-1.png" class="galImg halfScale" style="opacity:1;top: 0px; left: 0px;" />
          <img src="/104/es/static/_content/44-2.png" class="galImg halfScale" style="opacity:0;top: 0px; left: 0px;" />
          <img src="/104/es/static/_content/44-3.png" class="galImg halfScale" style="opacity:0;top: 0px; left: 0px;" />
          <img src="/104/es/static/_content/44-4.png" class="galImg halfScale" style="opacity:0;top: 0px; left: 0px;" />
          <img src="/104/es/static/_content/44-5.png" class="galImg halfScale" style="opacity:0;top: 0px; left: 0px;" />
          <img src="/104/es/static/_content/44-6.png" class="galImg halfScale" style="opacity:0;top: 0px; left: 0px;" />
          <img src="/104/es/static/_content/44-7.png" class="galImg halfScale" style="opacity:0;top: 0px; left: 0px;" />
        </div>
        <div id="box1" class="abs pointer" onclick="changeGalleryIndexTo('interview', 0)" style="top: 450px; right: 22px; width: 132px; height: 85px;"></div>
        <div id="box2" class="abs pointer" onclick="changeGalleryIndexTo('interview', 1)" style="top: 542px; right: 22px; width: 132px; height: 85px;"></div>
        <div id="box3" class="abs pointer" onclick="changeGalleryIndexTo('interview', 2)" style="top: 635px; right: 22px; width: 132px; height: 85px;"></div>
        <div id="box4" class="abs pointer" onclick="changeGalleryIndexTo('interview', 3)" style="top: 725px; right: 22px; width: 132px; height: 85px;"></div>
        <div id="box5" class="abs pointer" onclick="changeGalleryIndexTo('interview', 4)" style="top: 820px; right: 22px; width: 132px; height: 85px;"></div>
        <div id="box6" class="abs pointer" onclick="changeGalleryIndexTo('interview', 5)" style="top: 914px; right: 22px; width: 132px; height: 85px;"></div>
        <div id="box7" class="abs pointer" onclick="changeGalleryIndexTo('interview', 6)" style="top: 1000px; right: 22px; width: 132px; height: 85px;"></div>

        <img id="44-arrow" class="pointer halfScaleBR" style="bottom:74px; right:805px;" onclick="Publish.nextPage();" src="/104/es/static/_content/44-next.jpg">
      `,
      "script": `
        function onPageEnter() {
          page44Anim = new TimelineMax()
          page44Anim
            .fromTo(idOf("44-arrow"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1}, 0.5)
        }
        var galleryIndex = {interview: 0}

        function changeGalleryIndexTo(galleryID,newIndex) {
        var gallery = document.getElementById(galleryID)
        var galleryImages = gallery.getElementsByClassName("galImg")
        var currentIndex = galleryIndex[galleryID]
        
        TweenMax.to(galleryImages[currentIndex], 0.2, {opacity:0});
        TweenMax.to(galleryImages[newIndex], 0.3, {opacity:1});
          
        clearActiveGalleryButtons(gallery)
        updateActiveGalleryButtonTo(gallery,newIndex)
        updateGalleryIndexTo(galleryID,newIndex)
        }

        function clearActiveGalleryButtons(gallery) {
          var galleryButtons = gallery.getElementsByClassName("galcta")
          try {
            Array.prototype.forEach.call(galleryButtons, function (galleryButton) {
              galleryButton.className = "abs pointer galcta"
            });
          }
          catch(err) {
            return;
          } 
        }

        function updateActiveGalleryButtonTo(gallery,newIndex) {
          var galleryButtons = gallery.getElementsByClassName("galcta")
          try {
          galleryButtons[newIndex].className = "abs pointer galcta galcta-s"
          }
          catch(err) {
            return;
          }
        }

        function updateGalleryIndexTo(galleryID,newIndex) {
          try {
            galleryIndex[galleryID] = newIndex
          }
          catch(err) {
            console.log(err)
          } 
          
        }

        function onPageLeave() {
          page44Anim.stop()
          changeGalleryIndexTo('interview', 0)
        }
      `,
      "searchText": `
      1. Cuéntanos sobre tu transición de Cadetes a Juniors. ¿Qué ha significado para ti?    

      En realidad, soy Cadete y Junior, así que en los campeonatos de Europa pude competir tanto en los sub-17 como en los sub-20 años. Entonces todavía no he hecho esa transición.
      
      
      
      2. ¿Cuáles son tus orígenes en la esgrima? ¿Cuánto tiempo has estado en la esgrima? Por favor explica tus experiencias de entrenamiento y orientación.
      
      Empecé a hacer esgrima hace siete años, gracias a mi hermana Aurora. ¡Desde el primer momento en que entré al salón, me enamoré de este fantástico deporte! Comencé con el florete, lo que me dio técnica, precisión y velocidad, pero después de algunos años, y sin ninguna expectativa particular, comencé a trabajar también con la espada. Los maestros que me han ayudado a crecer como esgrimista desde el principio son Maria Pia Bulgherini para el florete y Massimo Ferrarese para la espada, pero realmente trabajan en simbiosis: fue genial tenerlos a ambos cerca del Campeonato de Europa en Sochi.
      
      
      
      3. ¿Cuáles son tus expectativas para Verona este año en la categoría Junior?  
      
      Nunca he participado en un Campeonato del Mundo Junior, y si llego a la marca con ellos, este año mi objetivo será dar lo mejor de mí. Además, un torneo en Italia siempre es algo especial. Más aún si se trata de un Campeonato del Mundo. Entonces no puedo esperar.
      
      
      
      4. ¿Cómo está tu condición física? ¿Qué áreas de esgrima y entrenamiento son fuertes y qué áreas son desafiantes para ti?
      
      Este año, con mi entrenador hemos trabajado mucho en el aspecto físico, pero también recibí mucha ayuda del baile, que he estudiado desde que tenía cinco años, y que incluso elegí para mi carrera académica. Espero llegar al Campeonato del Mundo de Verona en las mejores condiciones posibles.
      
      
      
      5. ¿Cómo será para ti competir en un Campeonato del Mundo en tu país de origen?
      
      Competir en un Campeonato del Mundo en casa es un gran honor para mí, y espero compartir con el público las mismas emociones que sentiré cuando llegue el momento.
      
      
      
      6. ¿Cuál es el mayor desafío al que te has enfrentado en la esgrima en el último año?
      
      Este año, el evento más importante en el que participé fue la final de la Copa del Mundo. Tener la oportunidad de enfrentarme a los mejores deportistas del mundo fue un gran honor, un sueño.
      
      
      
      7. ¿Competirás en el evento Junior masculino por equipos? Si es así, ¿qué esperas en el Campeonato del Mundo Junior y Cadete para el equipo de Italia?
      
      Todavía no sé si estaré compitiendo en la prueba Junior por equipos, pero si puedo hacerlo, estoy seguro de que todo el equipo dará el 100% para lograr el mayor objetivo: ganar para nuestro maravilloso país y para todos los que vayan a animarnos.
      
      
      `,
        "mobileHtml": `

        <img id="interviewimg" src="/104/es/static/_mobile/pg43-interview.jpg">

        <p><b>Cuéntanos sobre tu transición de Cadetes a Juniors. ¿Qué ha significado para ti? </b></p>
        
        <p>En realidad, soy Cadete y Junior, así que en los campeonatos de Europa pude competir tanto en los sub-17 como en los sub-20 años. Entonces todavía no he hecho esa transición.</p>

        <p><b>¿Cuáles son tus orígenes en la esgrima? ¿Cuánto tiempo has estado en la esgrima? Por favor explica tus experiencias de entrenamiento y orientación.</b></p>

        <p>Empecé a hacer esgrima hace siete años, gracias a mi hermana Aurora. ¡Desde el primer momento en que entré al salón, me enamoré de este fantástico deporte! Comencé con el florete, lo que me dio técnica, precisión y velocidad, pero después de algunos años, y sin ninguna expectativa particular, comencé a trabajar también con la espada. Los maestros que me han ayudado a crecer como esgrimista desde el principio son Maria Pia Bulgherini para el florete y Massimo Ferrarese para la espada, pero realmente trabajan en simbiosis: fue genial tenerlos a ambos cerca del Campeonato de Europa en Sochi.</p>

        <p><b>¿Cuáles son tus expectativas para Verona este año en la categoría Junior?</b></p>
        
        <p>Nunca he participado en un Campeonato del Mundo Junior, y si llego a la marca con ellos, este año mi objetivo será dar lo mejor de mí. Además, un torneo en Italia siempre es algo especial. Más aún si se trata de un Campeonato del Mundo. Entonces no puedo esperar.</p>

        <p><b>¿Cómo está tu condición física? ¿Qué áreas de esgrima y entrenamiento son fuertes y qué áreas son desafiantes para ti?</b></p>

        <p>Este año, con mi entrenador hemos trabajado mucho en el aspecto físico, pero también recibí mucha ayuda del baile, que he estudiado desde que tenía cinco años, y que incluso elegí para mi carrera académica. Espero llegar al Campeonato del Mundo de Verona en las mejores condiciones posibles.</p>

        <p><b>¿Cómo será para ti competir en un Campeonato del Mundo en tu país de origen?</b></p>

        <p>Competir en un Campeonato del Mundo en casa es un gran honor para mí, y espero compartir con el público las mismas emociones que sentiré cuando llegue el momento.</p>

        <p><b>¿Cuál es el mayor desafío al que te has enfrentado en la esgrima en el último año?</b></p>

        <p>Este año, el evento más importante en el que participé fue la final de la Copa del Mundo. Tener la oportunidad de enfrentarme a los mejores deportistas del mundo fue un gran honor, un sueño.</p>

        <p><b>¿Competirás en el evento Junior masculino por equipos? Si es así, ¿qué esperas en el Campeonato del Mundo Junior y Cadete para el equipo de Italia?</b></p>

        <p>Todavía no sé si estaré compitiendo en la prueba Junior por equipos, pero si puedo hacerlo, estoy seguro de que todo el equipo dará el 100% para lograr el mayor objetivo: ganar para nuestro maravilloso país y para todos los que vayan a animarnos.</p>

        `
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 44,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg45.jpg",
      "zoom": null,
      "content": `
       <div class="contentLink" style="bottom:405px;right:160px;width:270px; height:120px;">
         <a href="http://www.swordhellas.com" target="_blank"></a>
       </div>
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "",
      "mobileHtml":`
      <a href="http://www.swordhellas.com" target="_blank">
        <img id="ad45img" src="/104/es/static/_mobile/pg45-swordhellas.jpg">
      </a>
      `
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "FED Daca",
      "index": 45,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg46.png",
      "zoom": null,
      "content": `
        <img class="46-title halfScale" src="/104/es/static/_content/46-t1.png" alt="" style="top: 50px; left: 35px;">
        <img class="46-title halfScale" src="/104/es/static/_content/46-t2.png" alt="" style="top: 141px; left: 35px;">
        <img class="46-title halfScale" src="/104/es/static/_content/46-t3.png" alt="" style="top: 223px; left: 35px;">
        <img class="46-st halfScale" src="/104/es/static/_content/46-st1.png" alt="" style="top: 230px; left: 778px;">
        <img class="46-st halfScale" src="/104/es/static/_content/46-st2.png" alt="" style="top: 270px; left: 778px;">
        <img id="46-line" class="halfScale" src="/104/es/static/_content/52-line.png" alt="" style="top: 279px; left: 776px;">
        <img id="46-arrow" class="pointer halfScaleBR" style="bottom:178px; right:0px;" onclick="Publish.nextPage();" src="/104/es/static/_content/51-next.png">
      `,
      "script": `
        function onPageEnter() {
          page46Anim = new TimelineMax()
          page46Anim
            .fromTo(cOf("46-title"), 0.5,{x:-100, opacity:0, }, {x:0, opacity:1}, 0.5)
            .fromTo(idOf("46-line"), 0.3,{opacity:0, y:50}, {y:0,opacity:1},"-=0.2")
            .fromTo(cOf("46-st"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1},"+=0.1")
            .fromTo(idOf("46-arrow"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
        }

        function onPageLeave() {
          page46Anim.stop()
        }
      `,
      "searchText": `
      BANGLADÉS ES SEDE DE LOS CAMPEONATOS NACIONALES 
DE ESGRIM

DACA, Bangladés
enero 2018
      `,
      "mobileHtml": `
      <h2>BANGLADÉS ES SEDE DE LOS CAMPEONATOS NACIONALES</h2>
      <p><b>DE ESGRIM<br>
      DACA, Bangladés
enero 2018</b></p>
      `
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "FED Daca",
      "index": 46,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg47.png",
      "zoom": null,
      "content": `
        <img id="47-arrow" class="pointer halfScaleBR" style="bottom:178px; right:21px;" onclick="Publish.nextPage();" src="/104/es/static/_content/51-next.png">
        <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img id="47-tw" class="halfScale pulse animatedpulse" src="/104/es/static/_content/green-tw.png" alt="" style="top: 422px; left: 54px;"></a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
        <img id="47-fa" class="halfScale pulse animatedpulse" src="/104/es/static/_content/green-fa.png" alt="" style="top: 422px; left: 124px;"></a>
        <img id="47-pin" class="halfScale" src="/104/es/static/_content/47-pin.png" alt="" style="top: 806px; left: 1104px;">
        <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
          <a href="http://www.fie.org/es" target="_blank"></a></div>
      `,
      "script": `
        function onPageEnter() {
          page47Anim = new TimelineMax()
          page47Anim
            .fromTo(idOf("47-arrow"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
        }

        function onPageLeave() {
          page47Anim.stop()
          removeContentLinks()
        }
      `,
      "searchText": `
      La 5.° Copa Presidente de campeonatos de esgrima se llevó a cabo recientemente en Daca, Bangladés, del 26 al 30 de diciembre.

El evento tuvo lugar en el estadio cubierto Shaheed Suhrawardy, con todas las armas representadas y un total aproximado de 350 participantes, tanto hombres como mujeres, que compitieron entre militares, asociaciones de esgrima, escuelas y clubes.

Cabe destacar que Bangladesh Ansar y VDP (tropas paramilitares) obtuvieron ocho medallas de oro, dos de plata y seis de bronce, por lo que fueron nombrados campeones generales del torneo. El Ejército de Bangladés recibió tres medallas de oro, una de plata y ocho de bronce y fue nombrado subcampeón del torneo. La Marina de Guerra de Bangladés obtuvo una medalla de oro, seis de plata y tres de bronce; La Guardia Fronteriza de Bangladés recibió tres medallas de plata y dos de bronce; y el Dhaka Commerce College (Escuela universitaria en Daca, Bangladés) obtuvo cinco medallas de bronce.

En la ceremonia de apertura se presentó al Honorable Ministro de Información Sr. Hasanul Haq Inu, MP del Gobierno de la República Popular de Bangladés como invitado de honor. El Dr. Atiur Rahman, ex Gobernador del Banco de Bangladés, fue el invitado de honor de la ceremonia de clausura. Dos árbitros extranjeros estuvieron presentes para garantizar la neutralidad, el Sr. Abhishek Karki (NEP) y el Sr. Sadesh Chandana (SRI).

Otros participantes que compitieron en el evento incluyeron la Mymensingh Fencing Association (Asociación de esgrima Mymensingh), Rajshahi Fencing Association (Asociación de esgrima Rajshahi), Quantum Cosmo School and College (Escuela y Colegio Quantum Cosmo), Mirpur Cosmo School and College (Escuela y Colegio Mirpur), Chittagong Fencing Association (Asociación de esgrima Chittagong) y Sylhet Fencing Association (Asociación de esgrima Sylhet). 
      `,
      "mobileHtml": `

        <img id="dhakaimg" src="/104/es/static/_mobile/pg46-dhaka2.jpg">

        <p>La 5.° Copa Presidente de campeonatos de esgrima se llevó a cabo recientemente en Daca, Bangladés, del 26 al 30 de diciembre.</p>

        <p>El evento tuvo lugar en el estadio cubierto Shaheed Suhrawardy, con todas las armas representadas y un total aproximado de 350 participantes, tanto hombres como mujeres, que compitieron entre militares, asociaciones de esgrima, escuelas y clubes.</p>

        <p>Cabe destacar que Bangladesh Ansar y VDP (tropas paramilitares) obtuvieron ocho medallas de oro, dos de plata y seis de bronce, por lo que fueron nombrados campeones generales del torneo. El Ejército de Bangladés recibió tres medallas de oro, una de plata y ocho de bronce y fue nombrado subcampeón del torneo. La Marina de Guerra de Bangladés obtuvo una medalla de oro, seis de plata y tres de bronce; La Guardia Fronteriza de Bangladés recibió tres medallas de plata y dos de bronce; y el Dhaka Commerce College (Escuela universitaria en Daca, Bangladés) obtuvo cinco medallas de bronce.</p>
        
        <p>En la ceremonia de apertura se presentó al Honorable Ministro de Información Sr. Hasanul Haq Inu, MP del Gobierno de la República Popular de Bangladés como invitado de honor. El Dr. Atiur Rahman, ex Gobernador del Banco de Bangladés, fue el invitado de honor de la ceremonia de clausura. Dos árbitros extranjeros estuvieron presentes para garantizar la neutralidad, el Sr. Abhishek Karki (NEP) y el Sr. Sadesh Chandana (SRI).</p>

        <p>Otros participantes que compitieron en el evento incluyeron la Mymensingh Fencing Association (Asociación de esgrima Mymensingh), Rajshahi Fencing Association (Asociación de esgrima Rajshahi), Quantum Cosmo School and College (Escuela y Colegio Quantum Cosmo), Mirpur Cosmo School and College (Escuela y Colegio Mirpur), Chittagong Fencing Association (Asociación de esgrima Chittagong) y Sylhet Fencing Association (Asociación de esgrima Sylhet).</p>

      `
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "FED Europea",
      "index": 47,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg48.png",
      "zoom": null,
      "content": `
        <img id="48-arrow" class="pointer halfScaleBR" style="bottom:178px; right:0px;" onclick="Publish.nextPage();" src="/104/es/static/_content/51-next.png">
        <img class="48-title halfScale" src="/104/es/static/_content/48-t1.png" alt="" style="top: 641px; left: -21px;">
        <img class="48-title halfScale" src="/104/es/static/_content/48-t2.png" alt="" style="top: 723px; left: -21px;">
        <img class="48-title halfScale" src="/104/es/static/_content/48-t3.png" alt="" style="top: 797px; left: -21px;">
        <img class="48-st halfScale" src="/104/es/static/_content/48-st1.png" alt="" style="top: 902px; left: 94px;">
        <img class="48-st halfScale" src="/104/es/static/_content/48-st2.png" alt="" style="top: 1012px; left: 94px;">
        <img id="48-line" class="halfScale" src="/104/es/static/_content/52-line.png" alt="" style="top: 983px; left: 87px;">
      `,
      "script": `
        function onPageEnter() {
          page48Anim = new TimelineMax()
          page48Anim
            .fromTo(cOf("48-title"), 0.5,{x:-100, opacity:0, }, {x:0, opacity:1},0.5)
            .fromTo(idOf("48-line"), 0.3,{opacity:0, y:50}, {y:0,opacity:1})
            .fromTo(cOf("48-st"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
            .fromTo(idOf("48-arrow"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
        }

        function onPageLeave() {
          page48Anim.stop()
        }
      `,
      "searchText": `LA FEDERACIÓN EUROPEA DE ESGRIMA LANZA NUEVO SITIO WEB

      SOCHI, RUSIA
5 DE MARZO DE 2018
      `,
      "mobileHtml": `

      <h2>LA FEDERACIÓN EUROPEA DE ESGRIMA LANZA NUEVO SITIO WEB</h2>

      <p><b>SOCHI, RUSIA <br>
      5 DE MARZO DE 2018</b></p>

      `
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "FED Europea",
      "index": 48,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg49.png",
      "zoom": null,
      "content": `
      <div class="addContentLink" style="top: 242px; left: 921px; width: 302px; height: 34px;">
        <a href="http://www.EuroFencing.info" target="_blank"></a>
      </div>
        <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img id="49-tw" class="halfScale pulse animatedpulse" src="/104/es/static/_content/green-tw.png" alt="" style="top: 422px; left: 54px;"></a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
        <img id="49-fa" class="halfScale pulse animatedpulse" src="/104/es/static/_content/green-fa.png" alt="" style="top: 422px; left: 124px;"></a>
        <a href="http://www.EuroFencing.info" target="_blank">
        <img id="49-globe" class="halfScale pulse animatedpulse" src="/104/es/static/_content/49-globe.png" alt="" style="top: 968px; left: 825px;"></a>
        </a>
        <img id="49-arrow" class="pointer halfScaleBR" style="bottom:178px; right:21px;" onclick="Publish.nextPage();" src="/104/es/static/_content/51-next.png">
        <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
          <a href="http://www.fie.org/es" target="_blank"></a></div>
      `,
      "script": `
        function onPageEnter() {
          page49Anim = new TimelineMax()
          page49Anim
            .fromTo(idOf("49-arrow"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
        }

        function onPageLeave() {
          page49Anim.stop()
          removeContentLinks()
        }
      `,
      "searchText": `
      La Federación Europea de Esgrima (FEE) desveló su nuevo sitio web, www.EuroFencing.info en la reciente apertura de los Campeonatos del mundo Junior y Cadete europeos de esgrima en Sochi, Rusia. 

      El sitio web, anunciado por el Presidente de la FEE, Stanislav Podznyakov, contiene encriptación de alto nivel y una imagen completamente nueva y rediseñada.
      En 2017 se implementó el portal de servicios para las federaciones de países miembros y esto se suma con un diseño y una estructura más limpia y agradable en general. El interés principal del sitio ha sido dar a las federaciones, a los esgrimistas y a los medios de comunicación, información simplificada y lineal que complemente los esfuerzos que la FFE realiza en redes sociales como Facebook, Instagram y Twitter.
      
      «Ha sido una parte importante de mis promesas electorales» enfatizó el presidente Podznyakov. «Ahora, el primer paso está realizado y encontrarán toda la información pertinente en el sitio web».
      
      Para aumentar la atracción del sitio, ofrece accesos directos a Facebook, Instagram y Twitter. También contiene extensas galerías de fotografías con imágenes de esgrima del renombrado artista/fotógrafo del esgrima, Augusto Bizzi. Además, ha sido mejorado y habilitado para subir y soportar múltiples tipos de contenido multimedia.
      
      Con el lanzamiento de este sitio web, la FEE abre nuevas áreas de comunicación digital e intercambio de información, por ejemplo con la próxima extensión del sitio web «Mi zona de esgrima».Esta característica mejora la colaboración en línea en la esgrima y aprovecha las herramientas, características e innovaciones tecnológicas del siglo XXI.
            
      Pulse aquí para ir sitio web oficial`,
      "mobileHtml": `

        <img id="websiteimg" src="/104/es/static/_mobile/pg48-website.jpg">

        <p>La Federación Europea de Esgrima (FEE) desveló su nuevo sitio web, <a href="http://www.EuroFencing.info" target="_blank">www.EuroFencing.info</a>, en la reciente apertura de los Campeonatos del mundo Junior y Cadete europeos de esgrima en Sochi, Rusia. 
        </p>

        <p>El sitio web, anunciado por el Presidente de la FEE, Stanislav Podznyakov, contiene encriptación de alto nivel y una imagen completamente nueva y rediseñada.
        En 2017 se implementó el portal de servicios para las federaciones de países miembros y esto se suma con un diseño y una estructura más limpia y agradable en general. El interés principal del sitio ha sido dar a las federaciones, a los esgrimistas y a los medios de comunicación, información simplificada y lineal que complemente los esfuerzos que la FFE realiza en redes sociales como Facebook, Instagram y Twitter.</p>

        <p>«Ha sido una parte importante de mis promesas electorales» enfatizó el presidente Podznyakov. «Ahora, el primer paso está realizado y encontrarán toda la información pertinente en el sitio web».</p>

        <p>Para aumentar la atracción del sitio, ofrece accesos directos a Facebook, Instagram y Twitter. También contiene extensas galerías de fotografías con imágenes de esgrima del renombrado artista/fotógrafo del esgrima, Augusto Bizzi. Además, ha sido mejorado y habilitado para subir y soportar múltiples tipos de contenido multimedia.</p>

        <p>Con el lanzamiento de este sitio web, la FEE abre nuevas áreas de comunicación digital e intercambio de información, por ejemplo con la próxima extensión del sitio web «Mi zona de esgrima».Esta característica mejora la colaboración en línea en la esgrima y aprovecha las herramientas, características e innovaciones tecnológicas del siglo XXI. 

        <p><a href="http://www.EuroFencing.info" target="_blank">Pulse aquí para ir sitio web oficial</a></p>
      `
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "FED Nepal",
      "index": 49,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg50.png",
      "zoom": null,
      "content": `
        <img id="50-arrow" class="pointer halfScaleBR" style="bottom:178px; right:0px;" onclick="Publish.nextPage();" src="/104/es/static/_content/51-next.png">
        <img class="50-title halfScale" src="/104/es/static/_content/50-t1.png" alt="" style="top: 110px; left: 87px;">
        <img class="50-title halfScale" src="/104/es/static/_content/50-t2.png" alt="" style="top: 191px; left: 87px;">
        <img class="50-st halfScale" src="/104/es/static/_content/50-st1.png" alt="" style="top: 318px; left: 246px;">
        <img class="50-st halfScale" src="/104/es/static/_content/50-st2.png" alt="" style="top: 360px; left: 246px;">
        <img id="50-line" class="halfScale" src="/104/es/static/_content/52-line.png" alt="" style="top: 322px; left: 202px;">
      `,
      "script": `
        function onPageEnter() {
          page50Anim = new TimelineMax()
          page50Anim
            .fromTo(cOf("50-title"), 0.5,{x:-100, opacity:0, }, {x:0, opacity:1},0.5)
            .fromTo(idOf("50-line"), 0.3,{opacity:0, y:50}, {y:0,opacity:1})
            .fromTo(cOf("50-st"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
            .fromTo(idOf("50-arrow"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
        }

        function onPageLeave() {
          page50Anim.stop()
        }
      `,
      "searchText": `TERCER CAMPEONATO NACIONAL EN KATMANDÚ 

      KATMANDÚ, NEPAL 
18 DE ENERO DE 2018
      `,
      "mobileHtml": `
        <h2>TERCER CAMPEONATO NACIONAL EN KATMANDÚ </h2>

        <p><b>KATMANDÚ, NEPAL<br>
        18 DE ENERO DE 2018</b></p>
      `
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "FED Nepal cont",
      "index": 50,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg51.png",
      "zoom": null,
      "content": `
        <img id="51-arrow" class="pointer halfScaleBR" style="bottom:178px; right:0px;" onclick="Publish.nextPage();" src="/104/es/static/_content/51-next.png">
        <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img id="51-tw" class="halfScale pulse animatedpulse" src="/104/es/static/_content/green-tw.png" alt="" style="top: 422px; left: 54px;"></a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
        <img id="51-fa" class="halfScale pulse animatedpulse" src="/104/es/static/_content/green-fa.png" alt="" style="top: 422px; left: 124px;"></a>
        <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
          <a href="http://www.fie.org/es" target="_blank"></a></div>
      `,
      "script": `
        function onPageEnter() {
          page51Anim = new TimelineMax()
          page51Anim
            .fromTo(idOf("51-arrow"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
        }

        function onPageLeave() {
          page51Anim.stop()
          removeContentLinks()
        }
      `,
      "searchText": `
      El tercer Campeonato Nacional de Esgrima de Nepal se ha completado en Katmandú del 4 al 6 de enero, como parte del proceso de selección de los XVIII Juegos Asiáticos (2018) y XIII Juegos del Sur Asiático (2019). 

      Cuatro equipos regionales y 96 esgrimistas individuales participaron en el evento que tuvo lugar entre los días 4-6 de enero.
      
      El Sr. Rajan Raj Khadka del Ejército de Nepal se hizo con la medalla de oro en el evento de florete individual masculino, y la Sra. Sunita Budhathoki, también del Ejército de Nepal, se hizo con el oro en florete femenino. 
      En espada, el Sr. Janga Giri del equipo de la Fuerza de Policía Armada de Nepal (APF) ganó el evento masculino, y la Sra. Anita Karki, también de APF, se llevó el oro femenino. En sable, el Sr. Amit Bhandari del equipo de la Zona Central y la Sra. Kamal Shrestha del Ejército de Nepal obtuvieron las respectivas medallas de oro.
      
      El Ejército de Nepal ganó el oro tanto en las pruebas por equipos de florete femenino como masculino. En el conjunto de espada, APF ganó el título masculino y el Ejército de Nepal consiguió el oro femenino. El equipo Zona Centro ganó en sable masculino y el Ejército de Nepal ganó la medalla de oro femenina.
      
      El Sr. Keshab Kumar Bista, secretario del Consejo Nacional de Deportes de Nepal, inauguró los Campeonatos que contaron con la asistencia de varios funcionarios y miembros del Comité Olímpico de Nepal. El vicepresidente del Consejo Nacional de Deportes de Nepal y secretario general del Comité Olímpico de Nepal, el Sr. Lama Tendi 
      Sherpa, distribuyó medallas junto con los miembros de la Asociación de Esgrima de Nepal.`,
      
      "mobileHtml": `

        <img id="nepalimg" src="/104/es/static/_mobile/pg50-nepal.jpg">

        <p>El tercer Campeonato Nacional de Esgrima de Nepal se ha completado en Katmandú del 4 al 6 de enero, como parte del proceso de selección de los XVIII Juegos Asiáticos (2018) y XIII Juegos del Sur Asiático (2019).</p>
      
        <p>Cuatro equipos regionales y 96 esgrimistas individuales participaron en el evento que tuvo lugar entre los días 4-6 de enero.</p>

        <p>El Sr. Rajan Raj Khadka del Ejército de Nepal se hizo con la medalla de oro en el evento de florete individual masculino, y la Sra. Sunita Budhathoki, también del Ejército de Nepal, se hizo con el oro en florete femenino. </p>

        <p>En espada, el Sr. Janga Giri del equipo de la Fuerza de Policía Armada de Nepal (APF) ganó el evento masculino, y la Sra. Anita Karki, también de APF, se llevó el oro femenino. En sable, el Sr. Amit Bhandari del equipo de la Zona Central y la Sra. Kamal Shrestha del Ejército de Nepal obtuvieron las respectivas medallas de oro.</p>

        <p>El Ejército de Nepal ganó el oro tanto en las pruebas por equipos de florete femenino como masculino. En el conjunto de espada, APF ganó el título masculino y el Ejército de Nepal consiguió el oro femenino. El equipo Zona Centro ganó en sable masculino y el Ejército de Nepal ganó la medalla de oro femenina.</p>
     
        <p>El Sr. Keshab Kumar Bista, secretario del Consejo Nacional de Deportes de Nepal, inauguró los Campeonatos que contaron con la asistencia de varios funcionarios y miembros del Comité Olímpico de Nepal. El vicepresidente del Consejo Nacional de Deportes de Nepal y secretario general del Comité Olímpico de Nepal, el Sr. Lama Tendi 
        Sherpa, distribuyó medallas junto con los miembros de la Asociación de Esgrima de Nepal.</p>
     
        `
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "FED Sociales",
      "index": 51,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg52.png",
      "zoom": null,
      "content": `
        <img id="52-arrow" class="pointer halfScaleBR" style="bottom:178px; right:0px;" onclick="Publish.nextPage();" src="/104/es/static/_content/51-next.png">

        <img class="52-title halfScale" src="/104/es/static/_content/52-t1.png" alt="" style="top: 223px; left: 790px;">
        <img class="52-title halfScale" src="/104/es/static/_content/52-t2.png" alt="" style="top: 266px; left: 790px;">
        <img class="52-title halfScale" src="/104/es/static/_content/52-t3.png" alt="" style="top: 322px; left: 790px;">
        <img class="52-title halfScale" src="/104/es/static/_content/52-t4.png" alt="" style="top: 377px; left: 790px;">
        <img class="52-title halfScale" src="/104/es/static/_content/52-t5.png" alt="" style="top: 443px; left: 790px;">
        <img class="52-st halfScale" src="/104/es/static/_content/52-st1.png" alt="" style="top: 510px; left: 915px;">
        <img class="52-st halfScale" src="/104/es/static/_content/52-st2.png" alt="" style="top: 552px; left: 915px;">
        <img id="52-line" class="halfScale" src="/104/es/static/_content/52-line.png" alt="" style="top: 512px; left: 875px;">

        <img id="52-f-icon" class="halfScale soc-med" src="/104/es/static/_content/52-mail.png" alt="" style="top: 224px; left: 109px;">
        <img id="52-f-icon" class="halfScale soc-med" src="/104/es/static/_content/52-insta.png" alt="" style="top: 644px; left: 75px;">
        <img id="52-f-icon" class="halfScale soc-med" src="/104/es/static/_content/52-fb.png" alt="" style="top: 73px; left: 301px;">
        <img id="52-f-icon" class="halfScale soc-med" src="/104/es/static/_content/52-in.png" alt="" style="top: 694px; left: 370px;">
        <img id="52-f-icon" class="halfScale soc-med" src="/104/es/static/_content/52-tw.png" alt="" style="top: 232px; left: 564px;">
        <img id="52-f-icon" class="halfScale soc-med" src="/104/es/static/_content/52-heart.png" alt="" style="top: 745px; left: 706px;">
        <img id="52-fade-h-icon" class="halfScale soc-med" src="/104/es/static/_content/52-faded-heart-sm.png" alt="" style="top: 110px; left: 384px;">

        <img id="52-fade-h-icon" class="halfScale soc-med" src="/104/es/static/_content/52-faded-tw.png" alt="" style="top: 130px; left: 1394px;">
        <img id="52-fade-h-icon" class="halfScale soc-med" src="/104/es/static/_content/52-faded-heart-mid.png" alt="" style="top: 64px; left: 1399px;">
        <img id="52-fade-h-icon" class="halfScale soc-med" src="/104/es/static/_content/52-faded-loca.png" alt="" style="top: 105px; left: 1335px;">
        
        <img id="52-fade-h-icon" class="halfScale soc-med" src="/104/es/static/_content/52-fade-heart-l.png" alt="" style="top: 792px; left: 1164px;">
        <img id="52-fade-h-icon" class="halfScale soc-med" src="/104/es/static/_content/52-faded-fb.png" alt="" style="top: 792px; left: 1296px;">
        <img id="52-fade-h-icon" class="halfScale soc-med" src="/104/es/static/_content/52-faded-insta.png" alt="" style="top: 892px; left: 1132px;">
        <img id="52-fade-h-icon" class="halfScale soc-med" src="/104/es/static/_content/52-faded-p.png" alt="" style="top: 827px; left: 1082px;">
      
      `,
      "script": `
        function onPageEnter() {
          page52Anim = new TimelineMax()
          page52Anim
            .fromTo(cOf("52-title"), 0.5,{x:-100, opacity:0}, {x:0, opacity:1},0.5)
            .fromTo(idOf("52-line"), 0.3,{opacity:0, y:50}, {y:0,opacity:1})
            .fromTo(cOf("52-st"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
            .fromTo(idOf("52-arrow"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
            .staggerFromTo(cOf("soc-med"), 0.3,{opacity:0}, {opacity:1}, 0.1)
            // .staggerFromTo(cOf("soc-med"), 0.3,{rotationX:-90, transformOrigin:"50% 100%"}, {rotationX:0}, 0.1)
        }

        function onPageLeave() {
          page52Anim.stop()
        }
      `,
      "searchText": `La esgrima obtiene la mejor puntuación en la clasificación olímpica de deportes en medios sociales

      LAUSANA, SUIZA 
22 de diciembre de 2017
      `,
      "mobileHtml": `
        <h2>La esgrima obtiene la mejor puntuación en la clasificación olímpica de deportes en medios sociales</h2>

        <p><b>LAUSANA, SUIZA  <br>
        22 de diciembre de 2017 </b></p>
      `
      ,
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "FED Sociales",
      "index": 52,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg53.png",
      "zoom": null,
      "content": `
        <img id="53-arrow" class="pointer halfScaleBR" style="bottom:178px; right:0px;" onclick="Publish.nextPage();" src="/104/es/static/_content/51-next.png">
        <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img id="53-tw" class="halfScale pulse animatedpulse" src="/104/es/static/_content/green-tw-big.png" alt="" style="top: 494px; left: 44px;">
        </a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
        <img id="53-fa" class="halfScale pulse animatedpulse" src="/104/es/static/_content/green-fb-big.png" alt="" style="top: 494px; left: 128px;"></a>
        <a href="https://www.instagram.com/fencing_fie/" target="_blank">
        <img id="53-inst" class="halfScale pulse animatedpulse" src="/104/es/static/_content/green-insta.png" alt="" style="top: 575px; left: 44px;">
        </a>
        <a href="https://www.youtube.com/user/FIEvideo" target="_blank">
        <img id="53-you" class="halfScale pulse animatedpulse" src="/104/es/static/_content/green-you.png" alt="" style="top: 575px; left: 128px;">
        </a>

        <img id="53-f-icon" class="halfScale soc-med2" src="/104/es/static/_content/53-tw.png" alt="" style="top: 258px; left: 342px;">
        <img id="53-f-icon" class="halfScale soc-med2" src="/104/es/static/_content/53-fb.png" alt="" style="top: 124px; left: 714px;">
        <img id="53-f-icon" class="halfScale soc-med2" src="/104/es/static/_content/53-heart.png" alt="" style="top: 259px; left: 922px;">
        <img id="53-f-icon" class="halfScale soc-med2" src="/104/es/static/_content/53-insta.png" alt="" style="top: 83px; left: 1097px;">
        <img id="53-f-icon" class="halfScale soc-med2" src="/104/es/static/_content/53-mail.png" alt="" style="top: 52px; left: 454px;">
        <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
          <a href="http://www.fie.org/es" target="_blank"></a>
        </div>
      `,
      "script": `
        function onPageEnter() {
          page53Anim = new TimelineMax()
          page53Anim
            .fromTo(idOf("53-arrow"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
            .staggerFromTo(cOf("soc-med2"), 0.3,{opacity:0}, {opacity:1}, 0.1)
        }

        function onPageLeave() {
          page53Anim.stop()
          removeContentLinks()
        }
      `,
      "searchText": `
      Un reciente y exhaustivo informe de los medios de sociales sobre los deportes olímpicos, realizado por TSE Consulting, una empresa de Burson-Marsteller, titulado ‘Olympic Sports Social Media Ranking' (Clasificación de los medios sociales para deportes olímpicos), examinó varias organizaciones y federaciones de deportes olímpicos y su rendimiento en plataformas como Facebook, Instagram, SnapChat, LinkedIn, Twitter, YouTube, entre otras.

La Federación Internacional de Esgrima (FIE) obtuvo valoraciones muy positivas en los artículos de Facebook e Instagram, en particular, como una de las federaciones deportivas “más activas”. La FIE se colocó en el noveno lugar (en Facebook) sobre todos los deportes olímpicos y organizaciones, donde los únicos deportes con puntuaciones mayores fueron el baloncesto, el tenis de mesa, el hockey sobre hielo y el atletismo (los otros fueron programas multideportivos u organizaciones como Olympic Channel y los Juegos Paralímpicos). 

La FIE mantiene su compromiso con la presencia continua y cada vez mayor en los medios sociales, haciendo partícipes a jugadores, aficionados, oficiales, organizaciones y entrenadores de todo el mundo en múltiples formas de comunicación. 

FUENTE: ‘2017 Olympic Sports Social Media Ranking', #OlympicRanking, por Burson Marsteller/TSE Consulting, diciembre de 2017
      `,
      "mobileHtml": `

      <img id="socialimg" src="/104/es/static/_mobile/pg52-socialmedia.jpg">

      <p>Un reciente y exhaustivo informe de los medios de sociales sobre los deportes olímpicos, realizado por TSE Consulting, una empresa de Burson-Marsteller, titulado ‘Olympic Sports Social Media Ranking' (Clasificación de los medios sociales para deportes olímpicos), examinó varias organizaciones y federaciones de deportes olímpicos y su rendimiento en plataformas como Facebook, Instagram, SnapChat, LinkedIn, Twitter, YouTube, entre otras.</p>
      <p>La Federación Internacional de Esgrima (FIE) obtuvo valoraciones muy positivas en los artículos de Facebook e Instagram, en particular, como una de las federaciones deportivas “más activas”. La FIE se colocó en el noveno lugar (en Facebook) sobre todos los deportes olímpicos y organizaciones, donde los únicos deportes con puntuaciones mayores fueron el baloncesto, el tenis de mesa, el hockey sobre hielo y el atletismo (los otros fueron programas multideportivos u organizaciones como Olympic Channel y los Juegos Paralímpicos). </p>
      did very well on Facebook and Instagram stories, in particular, as one of the 'most active' sports federations. The FIE took ninth place (on Facebook) overall among all Olympic sports and organisations, with the only sports with higher scores being basketball, table tennis, ice hockey, and athletics (the others were multi-sport programs or organizations such as the Olympic Channel and the Paralympic Games).
      <p>La FIE mantiene su compromiso con la presencia continua y cada vez mayor en los medios sociales, haciendo partícipes a jugadores, aficionados, oficiales, organizaciones y entrenadores de todo el mundo en múltiples formas de comunicación. </p>
      <p>FUENTE: ‘2017 Olympic Sports Social Media Ranking', #OlympicRanking, por Burson Marsteller/TSE Consulting, diciembre de 2017 </p>
      `
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "FED Uganda",
      "index": 53,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg54.png",
      "zoom": null,
      "content": `
        <div class="rotation54">
        <img id="54-title" class="halfScale" src="/104/es/static/_content/54-title.png" alt="" style="top: 501px; left: 164px;">
        <img id="54-sub" class="halfScale" src="/104/es/static/_content/54-sub.png" alt="" style="top: 976px; left: 508px;">
        <img id="54-line" class="halfScale" src="/104/es/static/_content/52-line.png" alt="" style="top: 976px; left: 465px;">
        </div>
        <img id="54-arrow" class="pointer halfScaleBR" style="bottom:178px; right:0px;" onclick="Publish.nextPage();" src="/104/es/static/_content/51-next.png">
      `,
      "script": `
        function onPageEnter() {
          page54Anim = new TimelineMax()
          page54Anim
            .fromTo(idOf("54-title"), 0.5,{x:-100, opacity:0}, {x:0, opacity:1},0.5)
            .fromTo(idOf("54-line"), 0.3,{opacity:0, y:50}, {y:0,opacity:1})
            .fromTo(idOf("54-sub"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
            .fromTo(idOf("54-arrow"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
        }

        function onPageLeave() {
          page54Anim.stop()
        }
      `,
      "searchText": `
      LA UFA PRESENTA UN INFORME POSITIVO

      KAMPALA, UGANDA 
      23 DE FEBRERO DE 2018
      `,
      "mobileHtml": `
      <h2>LA UFA PRESENTA UN INFORME POSITIVO</h2>

      <p><b>KAMPALA, UGANDA <br>
      23 DE FEBRERO DE 2018</b></p>
      `
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "FED Uganda",
      "index": 54,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg55.png",
      "zoom": null,
      "content": `
        <img id="55-arrow" class="pointer halfScaleBR" style="bottom:178px; right:21px;" onclick="Publish.nextPage();" src="/104/es/static/_content/51-next.png">
        <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img id="55-tw" class="halfScale pulse animatedpulse" src="/104/es/static/_content/green-tw.png" alt="" style="top: 422px; left: 54px;"></a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
        <img id="55-fa" class="halfScale pulse animatedpulse" src="/104/es/static/_content/green-fa.png" alt="" style="top: 422px; left: 124px;"></a>
        <a href="http://fie.org/uploads/18/94571-UFA%20PERORT%202017%20-%202018%20FINAL%20EDIT.pdf" target="_blank">
        <img id="55-i" class="halfScale" src="/104/es/static/_content/55-info-sym.png" alt="" style="top: 931px; left: 854px;">
        </a>
        <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
          <a href="http://www.fie.org/es" target="_blank"></a></div>
      `,
      "script": `
        function onPageEnter() {
          page55Anim = new TimelineMax()
          page55Anim
            .fromTo(idOf("55-arrow"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
        }

        function onPageLeave() {
          page55Anim.stop()
          removeContentLinks()
        }
      `,
      "searchText": `La Asociación de Esgrima de Uganda (UFA) acaba de publicar su informe anual para 2017, presentado una perspectiva positiva para 2018 y además de presentarse como una de las federaciones nacionales más nuevas que forman parte de la FIE. 
      
      La UFA participó activamente en el Día Mundial de Esgrima del pasado mes de septiembre y continuó desarrollando centros de esgrima regionales para llevar la esgrima a las diversas áreas del país. Con la ayuda de numerosas federaciones (incluyendo las federaciones de esgrima italiana, estadounidense y británica, entre otras), la UFA está ganando impulso para desarrollar la esgrima en Uganda y sobre todo en África. También ha recibido ayuda de la organización «Para el futuro de la esgrima» y del gobierno de Uganda, entre otras entidades.
      
      La UFA sigue trabajando en el desarrollo de infraestructuras, como encontrar espacio permanente para oficinas, abrir clubes y centros de esgrima, y encontrar instructores con talento y recursos suficientes no solo para construir, sino también para mantener el deporte. La UFA reconoce y presenta la contabilidad completa de su actividad en su informe, ya sea tanto para equipo para pruebas (como pistas y equipo de puntuación), como para equipo de esgrima para personas o fondos. También presenta un plan completo de futuro con responsabilidades, metas, costes, plazos y resultados esperados.

      Para ver el informe completo, pulse aquí:`,
      "mobileHtml": `

        <img id="ugandaimg" src="/104/es/static/_mobile/pg54-uganda.jpg">

          <p>La Asociación de Esgrima de Uganda (UFA) acaba de publicar su informe anual para 2017, presentado una perspectiva positiva para 2018 y además de presentarse como una de las federaciones nacionales más nuevas que forman parte de la FIE. </p>
          <p>La UFA participó activamente en el Día Mundial de Esgrima del pasado mes de septiembre y continuó desarrollando centros de esgrima regionales para llevar la esgrima a las diversas áreas del país. Con la ayuda de numerosas federaciones (incluyendo las federaciones de esgrima italiana, estadounidense y británica, entre otras), la UFA está ganando impulso para desarrollar la esgrima en Uganda y sobre todo en África. También ha recibido ayuda de la organización «Para el futuro de la esgrima» y del gobierno de Uganda, entre otras entidades.</p>

          <p>La UFA sigue trabajando en el desarrollo de infraestructuras, como encontrar espacio permanente para oficinas, abrir clubes y centros de esgrima, y encontrar instructores con talento y recursos suficientes no solo para construir, sino también para mantener el deporte. La UFA reconoce y presenta la contabilidad completa de su actividad en su informe, ya sea tanto para equipo para pruebas (como pistas y equipo de puntuación), como para equipo de esgrima para personas o fondos. También presenta un plan completo de futuro con responsabilidades, metas, costes, plazos y resultados esperados.</p>

          <p><a href="http://fie.org/uploads/18/94571-UFA%20PERORT%202017%20-%202018%20FINAL%20EDIT.pdf" target="_blank">Para ver el informe completo, pulse aquí</a></p>
      `
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 55,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg56.png",
      "zoom": null,
      "content": `
        <div class="contentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
         <a href="http://corp.megafon.com" target="_blank"></a>
       </div>
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "",
      "mobileHtml": `
      <a href="http://corp.megafon.com" target="_blank">
        <img id="ad56img" src="/104/es/static/_mobile/pg56-megafon.png">
      </a>
      `
    }],
    [{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "News",
      "index": 56,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg57.png",
      "zoom": null,
      "content": `
      
      <img id="57-title" class="halfScale" src="/104/es/static/_content/57-title.png" alt="" style="top: 133px; left: 90px;">
      <img id="57-t1" class="halfScale" src="/104/es/static/_content/57-text-1.png" alt="" style="top: 418px; left: 98px;">
      <img id="57-t2" class="halfScale" src="/104/es/static/_content/57-text-2.png" alt="" style="top: 386px; left: 1024px;">
      <img id="57-t3" class="halfScale" src="/104/es/static/_content/57-text-3.png" alt="" style="top: 660px; left: 1021px;">
      <!-- <img id="57-arrow" class="pointer halfScaleBR" style="bottom:84px; right:22px;" onclick="Publish.nextPage();" src="/104/es/static/_content/57-next.png"> -->
      
      <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;"><a href="http://www.fie.org/es" target="_blank"></a></div>
      <div class="addContentLink" style="top: 601px; left: 102px; width: 270px; height: 34px;" onclick="showOverlay('news-pop-1')"></div>
      <div class="addContentLink" style="top: 514px; left: 1022px; width: 220px; height: 34px;" onclick="showOverlay('news-pop-2')"></div>
      <div class="addContentLink" style="top: 872px; left: 1022px; width: 220px; height: 34px;" onclick="showOverlay('news-pop-3')"></div>

      <div id="news-pop-1" class="standardTransition contentOverlay hidden noclick">
        <img id="57-pop-1a-bg" src="/104/es/static/_content/pg57-pop1-1.png">
        <img id="57-pop-1b-bg" style="opacity:0" src="/104/es/static/_content/pg57-pop1-2.png">
        <img id="57-pop-1a" class="halfScale" style="left:90px; top:160px" src="/104/es/static/_content/57-news1-1.png">
        <img id="57-pop-1b" class="halfScale" style="left:90px; top:160px; opacity:0" src="/104/es/static/_content/57-news1-2.png">
        <img id="57-pop-1bimg" class="halfScale" style="left:786px; top:550px; opacity:0" src="/104/es/static/_content/57-news-1-2-img.jpg">
        <img id="57-pg-1a" class="halfScale pointer" style="left:785px; top:889px" onclick="pop1a()" src="/104/es/static/_content/57-pg1.png">
        <img id="57-pg-1b" class="halfScale pointer" style="left:1124px; top:894px; opacity:0" onclick="pop1b()" src="/104/es/static/_content/57-pg2.png">
        <img id="57-close" class="halfScaleR pointer" style=" top:52px; right:54px;" onclick="hideOverlay('news-pop-1'); pop1a();" src="/104/es/static/_content/57-close.png"></div>
      </div>

      <div id="news-pop-2" class="standardTransition contentOverlay hidden noclick">
        <img class="" src="/104/es/static/_content/pg57-pop2.png">
        <img id="57-pop-2a" class="halfScale" style="left:90px; top:243px" src="/104/es/static/_content/57-news2.png">
        <div class="contentLink abs" style="top:691px; left:226px; width:185px; height:30px;">
          <a href="http://www.cpe-fie.org" target="_blank"></a>
        </div>
        <div class="contentLink abs" style="bottom:121px; right:588px; width:60px; height:30px;">
          <a href="http://fie.org/es/uploads/18/93963-CPE%202017%20Summary.pdf" target="_blank"></a>
        </div>
        <img id="57-close-2" class="halfScaleR pointer" style=" top:52px; right:54px;" onclick="hideOverlay('news-pop-2')" src="/104/es/static/_content/57-close.png"></div>
      </div>

      <div id="news-pop-3" class="standardTransition contentOverlay hidden noclick">
        <img class="" src="/104/es/static/_content/pg57-pop3.png">
        <img id="57-pop-3a" class="halfScale" style="left:90px; top:333px" src="/104/es/static/_content/57-news3.png">
        <img id="57-pop-3img" class="halfScale" style="left:804px; top:333px" src="/104/es/static/_content/57-news3-img.png">
        <img id="57-close-2" class="halfScaleR pointer" style=" top:52px; right:54px;" onclick="hideOverlay('news-pop-3')" src="/104/es/static/_content/57-close.png"></div>
      </div>
      `,
      "script": `
        function onPageEnter() {
          page57Anim = new TimelineMax()
          page57Anim
            .fromTo(idOf("57-title"), 0.5,{x:-100, opacity:0}, {x:0, opacity:1, onComplete: addContentLinks},0.5)
            //.fromTo(idOf("57-arrow"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
        }

        function pop1a() {
          idOf("57-pop-1a-bg").style.opacity = 1
          idOf("57-pop-1b-bg").style.opacity = 0
          idOf("57-pop-1a").style.opacity = 1
          idOf("57-pg-1b").style.opacity = 0
          idOf("57-pop-1b").style.opacity = 0
          idOf("57-pop-1bimg").style.opacity = 0
          idOf("57-pg-1a").style.opacity = 1
        }

        function pop1b() {
          idOf("57-pop-1a-bg").style.opacity = 0
          idOf("57-pop-1b-bg").style.opacity = 1
          idOf("57-pop-1b").style.opacity = 1
          idOf("57-pop-1bimg").style.opacity = 1
          idOf("57-pg-1a").style.opacity = 0
          idOf("57-pop-1a").style.opacity = 0
          idOf("57-pg-1b").style.opacity = 1
        }

        function onPageLeave() {
          page57Anim.stop()
          hideOverlay('news-pop-1')
          hideOverlay('news-pop-2')
          hideOverlay('news-pop-3')
          pop1a()
          removeContentLinks()
        }
      `,
      "searchText": `
      1 NOTICIAS DE LA FIE

      A un año de « ¡Dona tu equipo de esgrima! »
      
      Después de un año, nos enorgullece anunciar que el programa ¡Dona tu equipo de esgrima! ha sido un éxito: más de 1300 artículos fueron recolectados en tres eventos, incluyendo el Campeonato del Mundo de Leipzig, las celebraciones de Esgrima suizas durante el primer Día Mundial de la Esgrima y la Copa del Mundo Príncipe Takamado de florete masculino de Tokio.
      
      Se recibieron donaciones de esgrimistas y fabricantes,y seis federaciones recibieron equipos para sus atletas. 
      El éxito del proyecto fue reconocido por primera vez cuando la FIE recibió una invitación para presentar el programa durante el Foro IF (Federación Internacional) 2017 con el enfoque de «Impacto de las Federaciones Internacionales: Liderando el camino hacia una agenda sostenible».
      
      En 2018, la FIE celebra su centésimo quinto aniversario. En esta ocasión, el programa continuará con un enfoque especial en las federaciones nuevas y en desarrollo. El próximo evento de recolección está programado para abril, durante el Campeonato del Mundo de Esgrima Junior y Cadete en Verona, Italia.
      
      Mientras que la campaña de 2018 de ¡Dona tu equipo de esgrima! está empezando, se está diseñando un balance detallado y un resumen para la primera edición del programa. Como se ha acordado previamente, las federaciones nacionales de esgrima beneficiarias prepararán informes sobre el progreso de los proyectos que presentaron en 2017 y cómo el equipo donado impactó en sus organizaciones y esgrimistas.
      
      Siguiendo una política de absoluta transparencia, en las próximas semanas la FIE compartirá la información recibida para disponer de un resumen público para todos los contribuyentes que quieran saber más sobre el uso final del equipo donado. El primer informe presentado es de la Federación Nacional de Colombia.
      
      Milagros en Colombia
      «Creo que estamos realizando milagros con este material, debido a que podemos llegar a regiones y pequeñas que 
      no tenían ni idea de lo que era la esgrima», comentó Vladimir Iwanoff, presidente de la Federación Colombiana de Esgrima (CFF).
      
      La CFF presentó un proyecto introduciendo la esgrima en el Distrito de Boyacá, cuya capital es Tunja en la Cordillera de los Andes a unos 130 km de Bogotá. Tunja es el destino final del equipo recolectado en Leipzig y entregado al entrenador Juan Miguel Paz, quien lo llevó a Colombia. Desde Tunja, el material se transporta regularmente a dos escuelas, Colegio Nueva Generación en Sachita y a la Institución Educativa Técnica San Felipe en Cucaita y después se devuelven al final de las clases. A partir de 2018, otras tres villas más se unirán a las actividades de esgrima: Siachoque, Soraca y Villa de Leyva.
      
      «Esta donación generó un impacto positivo en el distrito de Boyacá», dijo el Presidente Iwanoff. «Ningún niño sabía lo que era la esgrima antes de la implementación de este proyecto».
      
      «Durante las clases de esgrima, a los niños se les enseña también un comportamiento adecuado como personas, ya que el uso de armas implica enseñar valores como el respeto por la vida y el juego limpio. Eso contribuye a la educación en general de una persona».
      
      El proyecto colombiano está dirigido por Heiner Rafael Ortega Mora y Carolina Tapasco Ospida, con el apoyo de los órganos de gobierno de las escuelas los cuales permiten el uso libre de las instalaciones escolares. El objetivo principal ahora es hacer de la esgrima una asignatura regular durante las clases de educación física en la escuela.
      
      Aunque el programa aún no se ha implementado, la estimación inicial, que alcanza a más de 100 estudiantes, 
      ya se ha superado, y 150 estudiantes de escuelas primarias y secundarias han estado expuestos a la esgrima por primera vez en sus vidas.

      2 NOTICIAS DE LA FIE

      Resumen de la CEP de las grandes competiciones del año 

      Ciudad de México, México, 24 de enero de 2018 Nos enorgullece informar que la Confederación Panamericana de Esgrima ha tenido un año muy ocupado trabajando en la continuación de las diversas líneas de acción de su Plan Estratégico de la siguiente manera:

      1. Planificación estratégica Todas las líneas de acción se encuentran en ejecución continua bajo la gestión metódica del rendimiento y ajustes.

      2. Desarrollo de una plataforma tecnológica para el apoyo de todas las operaciones El lanzamiento de a página web de la CPE www.cpe-fie.org constituye un hito para la línea de acción estratégica de tecnologías de la información que avanza hacia el desarrollo de aplicaciones basadas en funciones de última generación de la plataformade gestión de contenidos Sitefinity que ahora posee la CPE.

      3. Iniciativas de gestión del conocimiento y trabajo colaborativo Estas iniciativas han sido posibles gracias a la creación de la nueva plataforma informática, permitiendo la transición de la planificación a la ejecución.

      4. Desarrollo de recursos humanos Los cursos de formación facilitados por la CPE han revolucionado sus planes de estudio incluyendo técnica y planificación del entrenamiento, reglas y arbitraje, neurociencias aplicadas a la esgrima y condicionamiento mental para alcanzar el alto rendimiento. Se añadirán a la plataforma informática aplicaciones web y contenidos.

      5. Apoyo para todas las competiciones e iniciativas internacionales y regionales de la FIE.

      6. Promoción de la esgrima en la región panamericana con iniciativas como “De la escuela a los juegos olímpicos”.

      7. Desarrollo de las relaciones inter-confederaciones.

      Haga clic aquí para saber más.

      3 NOTICIAS DE LA FIE

      Pictograma Esgrima de Los Juegos Olímpicos de La Juventud 

      Los pictogramas de los Juegos Olímpicos de la Juventud Buenos Aires 2018 fueron diseñados por cientos de niños en escuelas toda la ciudad. La primera parte del proceso consistió en fotografiar a los atletas en poses técnicas propias de cada disciplina.

      La fotografías fueron luego usadas como plantilla para que los niños perfilaran la pose del atleta de una vez, sin levantar el lápiz de la fotografía. Luego un grupo de diseñadores buscó puntos comunes en los dibujos para crear los pictogramas definitivos.
      `,

      "mobileHtml": `

      <h2>A un año de « ¡Dona tu equipo de esgrima! »</h2>

      <img id="newsimg" src="/104/es/static/_mobile/pg57-news.jpg">

      <p>Después de un año, nos enorgullece anunciar que el programa ¡Dona tu equipo de esgrima! ha sido un éxito: más de 1300 artículos fueron recolectados en tres eventos, incluyendo el Campeonato del Mundo de Leipzig, las celebraciones de Esgrima suizas durante el primer Día Mundial de la Esgrima y la Copa del Mundo Príncipe Takamado de florete masculino de Tokio.</p>

      <p>Se recibieron donaciones de esgrimistas y fabricantes,y seis federaciones recibieron equipos para sus atletas. 
      El éxito del proyecto fue reconocido por primera vez cuando la FIE recibió una invitación para presentar el programa durante el Foro IF (Federación Internacional) 2017 con el enfoque de «Impacto de las Federaciones Internacionales: Liderando el camino hacia una agenda sostenible».</p>

      <p>En 2018, la FIE celebra su centésimo quinto aniversario. En esta ocasión, el programa continuará con un enfoque especial en las federaciones nuevas y en desarrollo. El próximo evento de recolección está programado para abril, durante el Campeonato del Mundo de Esgrima Junior y Cadete en Verona, Italia.</p>

      <p>Mientras que la campaña de 2018 de ¡Dona tu equipo de esgrima! está empezando, se está diseñando un balance detallado y un resumen para la primera edición del programa. Como se ha acordado previamente, las federaciones nacionales de esgrima beneficiarias prepararán informes sobre el progreso de los proyectos que presentaron en 2017 y cómo el equipo donado impactó en sus organizaciones y esgrimistas.</p>

      <p>Siguiendo una política de absoluta transparencia, en las próximas semanas la FIE compartirá la información recibida para disponer de un resumen público para todos los contribuyentes que quieran saber más sobre el uso final del equipo donado. El primer informe presentado es de la Federación Nacional de Colombia.</p>

      <p>Milagros en Colombia</p>

      <p>«Creo que estamos realizando milagros con este material, debido a que podemos llegar a regiones y pequeñas que 
      no tenían ni idea de lo que era la esgrima», comentó Vladimir Iwanoff, presidente de la Federación Colombiana de Esgrima (CFF).</p>
      <p>La CFF presentó un proyecto introduciendo la esgrima en el Distrito de Boyacá, cuya capital es Tunja en la Cordillera de los Andes a unos 130 km de Bogotá. Tunja es el destino final del equipo recolectado en Leipzig y entregado al entrenador Juan Miguel Paz, quien lo llevó a Colombia. Desde Tunja, el material se transporta regularmente a dos escuelas, Colegio Nueva Generación en Sachita y a la Institución Educativa Técnica San Felipe en Cucaita y después se devuelven al final de las clases. A partir de 2018, otras tres villas más se unirán a las actividades de esgrima: Siachoque, Soraca y Villa de Leyva.</p>

      <p>«Esta donación generó un impacto positivo en el distrito de Boyacá», dijo el Presidente Iwanoff. «Ningún niño sabía lo que era la esgrima antes de la implementación de este proyecto».</p>

      <p>«Durante las clases de esgrima, a los niños se les enseña también un comportamiento adecuado como personas, ya que el uso de armas implica enseñar valores como el respeto por la vida y el juego limpio. Eso contribuye a la educación en general de una persona».
      </p>

      <p>El proyecto colombiano está dirigido por Heiner Rafael Ortega Mora y Carolina Tapasco Ospida, con el apoyo de los órganos de gobierno de las escuelas los cuales permiten el uso libre de las instalaciones escolares. El objetivo principal ahora es hacer de la esgrima una asignatura regular durante las clases de educación física en la escuela.
      </p>

      <p>Aunque el programa aún no se ha implementado, la estimación inicial, que alcanza a más de 100 estudiantes, 
      ya se ha superado, y 150 estudiantes de escuelas primarias y secundarias han estado expuestos a la esgrima por primera vez en sus vidas.</p>

      <h2>Resumen de la CEP de las grandes competiciones del año </h2>

      <p>Ciudad de México, México, 24 de enero de 2018 Nos enorgullece informar que la Confederación Panamericana de Esgrima ha tenido un año muy ocupado trabajando en la continuación de las diversas líneas de acción de su Plan Estratégico de la siguiente manera:</p>

      <p>1. Planificación estratégica Todas las líneas de acción se encuentran en ejecución continua bajo la gestión metódica del rendimiento y ajustes.</p>

      <p>2. Desarrollo de una plataforma tecnológica para el apoyo de todas las operaciones El lanzamiento de a página web de la CPE <a href="http://www.cpe-fie.org" target="_blank">www.cpe-fie.org</a> constituye un hito para la línea de acción estratégica de tecnologías de la información que avanza hacia el desarrollo de aplicaciones basadas en funciones de última generación de la plataformade gestión de contenidos Sitefinity que ahora posee la CPE.</p>

      <p>3. Iniciativas de gestión del conocimiento y trabajo colaborativo Estas iniciativas han sido posibles gracias a la creación de la nueva plataforma informática, permitiendo la transición de la planificación a la ejecución.</p>

      <p>4. Desarrollo de recursos humanos Los cursos de formación facilitados por la CPE han revolucionado sus planes de estudio incluyendo técnica y planificación del entrenamiento, reglas y arbitraje, neurociencias aplicadas a la esgrima y condicionamiento mental para alcanzar el alto rendimiento. Se añadirán a la plataforma informática aplicaciones web y contenidos.</p>

      <p>5. Apoyo para todas las competiciones e iniciativas internacionales y regionales de la FIE.</p>

      <p>6. Promoción de la esgrima en la región panamericana con iniciativas como “De la escuela a los juegos olímpicos”.</p>

      <p>7. Desarrollo de las relaciones inter-confederaciones.
      </p>

      <p><a href="http://fie.org/es/uploads/18/93963-CPE%202017%20Summary.pdf" target="_blank">Haga clic aquí para saber más.</a></p>

      <h2>Pictograma Esgrima de Los Juegos Olímpicos de La Juventud</h2>

      <p>Los pictogramas de los Juegos Olímpicos de la Juventud Buenos Aires 2018 fueron diseñados por cientos de niños en escuelas toda la ciudad. La primera parte del proceso consistió en fotografiar a los atletas en poses técnicas propias de cada disciplina.</p>

      <p>La fotografías fueron luego usadas como plantilla para que los niños perfilaran la pose del atleta de una vez, sin levantar el lápiz de la fotografía. Luego un grupo de diseñadores buscó puntos comunes en los dibujos para crear los pictogramas definitivos.</p>
      `
      
    }],
  ],
  "script": `
    function idOf(id) {
      return document.getElementById(id)
    }

    function cOf(klass) {
      return document.getElementsByClassName(klass)
    }
    
    function removeContentLinks() {
      var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
      contentLinks.map(function callback(e) { 
        return e.className = 'addContentLink'
      })
    }

    function addContentLinks() {
      var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
      contentLinks.map(function callback(e) {
        return e.className = 'contentLink addContentLink'
      })
    }

    function showOverlay(idx) {
      idOf(idx).className = 'contentOverlay visible'
    }

    function hideOverlay(idx) {
      idOf(idx).className = 'contentOverlay hidden noclick'
    }
  `,
  "mobilePages":[{
      "title": "Escrime XXI N⁰ 104",
      "cssClass": "cover mobile-p1",
      "hideInMenu": false,
      "pageLinks": [{
        "index": 0,
        "subIndex": 0
      }]
    },
    {
      "title": "Anuncio",
      "cssClass": "advert",
      "hideInMenu": true,
      "pageLinks": [{
        "index": 2,
        "subIndex": 0
      }]
    },
    {
      "title": "Comité Ejecutivo de la FIE",
      "cssClass": "aqua",
      "hideInMenu": false,
      "pageLinks": [{
        "index": 4,
        "subIndex": 0
      }]
    },
    {
      "title": "Foreword",
      "cssClass": "aqua",
      "hideInMenu": false,
      "pageLinks": [{
        "index": 5,
        "subIndex": 0
      }]
    },
    {
      "title": "Anuncio",
      "cssClass": "advert",
      "hideInMenu": true,
      "pageLinks": [{
        "index": 6,
        "subIndex": 0
      }]
    },
    {
      "title": "Anuncio",
      "cssClass": "advert",
      "hideInMenu": true,
      "pageLinks": [{
        "index": 7,
        "subIndex": 0
      }]
    },
    {
      "title": "Algiers",
      "cssClass": "red",
      "hideInMenu": false,
      "pageLinks": [{
          "index": 8,
          "subIndex": 0
        },
        {
          "index": 9,
          "subIndex": 0
        },
      ]
    },
    {
      "title": "Baltimore",
      "cssClass": "red",
      "hideInMenu": false,
      "pageLinks": [{
          "index": 10,
          "subIndex": 0
        },
        {
          "index": 11,
          "subIndex": 0
        },
      ]
    },
    {
      "title": "Barcelona",
      "cssClass": "red",
      "hideInMenu": false,
      "pageLinks": [{
          "index": 12,
          "subIndex": 0
        },
        {
          "index": 13,
          "subIndex": 0
        },
      ]
    },
    {
      "title": "Anuncio",
      "cssClass": "advert",
      "hideInMenu": true,
      "pageLinks": [{
        "index": 14,
        "subIndex": 0
      }]
    },
    {
      "title": "Anuncio",
      "cssClass": "advert",
      "hideInMenu": true,
      "pageLinks": [{
        "index": 15,
        "subIndex": 0
      }]
    },
    {
      "title": "Bonn",
      "cssClass": "red",
      "hideInMenu": false,
      "pageLinks": [{
          "index": 16,
          "subIndex": 0
        },
        {
          "index": 17,
          "subIndex": 0
        },
      ]
    },
    {
      "title": "La Habana",
      "cssClass": "red",
      "hideInMenu": false,
      "pageLinks": [{
          "index": 18,
          "subIndex": 0
        },
        {
          "index": 19,
          "subIndex": 0
        },
      ]
    },
    {
      "title": "Anuncio",
      "cssClass": "advert",
      "hideInMenu": true,
      "pageLinks": [{
        "index": 20,
        "subIndex": 0
      }]
    },
    {
      "title": "Anuncio",
      "cssClass": "advert",
      "hideInMenu": true,
      "pageLinks": [{
        "index": 21,
        "subIndex": 0
      }]
    },
    {
      "title": "Heidenheim",
      "cssClass": "red",
      "hideInMenu": false,
      "pageLinks": [{
          "index": 22,
          "subIndex": 0
        },
        {
          "index": 23,
          "subIndex": 0
        },
      ]
    },
    {
      "title": "Katowice",
      "cssClass": "red",
      "hideInMenu": false,
      "pageLinks": [{
          "index": 24,
          "subIndex": 0
        },
        {
          "index": 25,
          "subIndex": 0
        },
      ]
    },
    {
      "title": "Anuncio",
      "cssClass": "advert",
      "hideInMenu": true,
      "pageLinks": [{
        "index": 26,
        "subIndex": 0
      }]
    },
    {
      "title": "Anuncio",
      "cssClass": "advert",
      "hideInMenu": true,
      "pageLinks": [{
        "index": 27,
        "subIndex": 0
      }]
    },
    {
      "title": "Padua",
      "cssClass": "red",
      "hideInMenu": false,
      "pageLinks": [{
          "index": 28,
          "subIndex": 0
        },
        {
          "index": 29,
          "subIndex": 0
        },
      ]
    },
    {
      "title": "París",
      "cssClass": "red",
      "hideInMenu": false,
      "pageLinks": [{
          "index": 30,
          "subIndex": 0
        },
        {
          "index": 31,
          "subIndex": 0
        },
      ]
    },
    {
      "title": "Anuncio",
      "cssClass": "advert",
      "hideInMenu": true,
      "pageLinks": [{
        "index": 32,
        "subIndex": 0
      }]
    },
    {
      "title": "Anuncio",
      "cssClass": "advert",
      "hideInMenu": true,
      "pageLinks": [{
        "index": 33,
        "subIndex": 0
      }]
    },
    {
      "title": "Richmond",
      "cssClass": "red",
      "hideInMenu": false,
      "pageLinks": [{
          "index": 34,
          "subIndex": 0
        },
        {
          "index": 35,
          "subIndex": 0
        },
      ]
    },
    {
      "title": "Varsovia",
      "cssClass": "red",
      "hideInMenu": false,
      "pageLinks": [{
          "index": 36,
          "subIndex": 0
        },
        {
          "index": 37,
          "subIndex": 0
        },
      ]
    },
    {
      "title": "Anuncio",
      "cssClass": "advert",
      "hideInMenu": true,
      "pageLinks": [{
        "index": 38,
        "subIndex": 0
      }]
    },
    {
      "title": "Mundo Junior y Cadet De Esgrima",
      "cssClass": "purple",
      "hideInMenu": false,
      "pageLinks": [{
          "index": 39,
          "subIndex": 0
        },
        {
          "index": 40,
          "subIndex": 0
        },
        {
          "index": 41,
          "subIndex": 0
        }
      ]
    },
    {
      "title": "Conozca A Los Atletas",
      "cssClass": "aqua",
      "hideInMenu": false,
      "pageLinks": [{
          "index": 42,
          "subIndex": 0
        },
        {
          "index": 43,
          "subIndex": 0
        }
      ]
    },
    {
      "title": "Anuncio",
      "cssClass": "advert",
      "hideInMenu": true,
      "pageLinks": [{
        "index": 44,
        "subIndex": 0
      }]
    },
    {
      "title": "FED Daca",
      "cssClass": "green",
      "hideInMenu": false,
      "pageLinks": [{
          "index": 45,
          "subIndex": 0
        },
        {
          "index": 46,
          "subIndex": 0
        },
      ]
    },
    {
      "title": "FED Europea",
      "cssClass": "green",
      "hideInMenu": false,
      "pageLinks": [{
          "index": 47,
          "subIndex": 0
        },
        {
          "index": 48,
          "subIndex": 0
        },
      ]
    },
    {
      "title": "FED Nepal",
      "cssClass": "green",
      "hideInMenu": false,
      "pageLinks": [{
          "index": 49,
          "subIndex": 0
        },
        {
          "index": 50,
          "subIndex": 0
        },
      ]
    },
    {
      "title": "Medios Sociales",
      "cssClass": "green",
      "hideInMenu": false,
      "pageLinks": [{
          "index": 51,
          "subIndex": 0
        },
        {
          "index": 52,
          "subIndex": 0
        },
      ]
    },
    {
      "title": "FED Uganda",
      "cssClass": "green",
      "hideInMenu": false,
      "pageLinks": [{
          "index": 53,
          "subIndex": 0
        },
        {
          "index": 54,
          "subIndex": 0
        },
      ]
    },
    {
      "title": "Anuncio",
      "cssClass": "advert",
      "hideInMenu": true,
      "pageLinks": [{
        "index": 55,
        "subIndex": 0
      }]
    },
    {
      "title": "Noticias de la FIE",
      "cssClass": "yellow",
      "hideInMenu": false,
      "pageLinks": [{
        "index": 56,
        "subIndex": 0
      }]
    },
  ],
  "mobileTemplate": null,
}



// WEBPACK FOOTER //
// ./src/document.js